export const LANG_ZH_NAME = 'zh';
export const LANG_ZH_TRANS = {
	'0030565001AE':'ELEMENTRA® ',
	'003056500368':'INTEGRA®',
	'003056500394':'ROTO-PACKER®',
	'003056500398':'ROTO-PACKER®',
	'0030565011A8':'ROTO-PACKER®',
	'0030565011AE':'ELEMENTRA®',
	'003056501200':'ROTO-PACKER®',
	'00305650121E':'INTEGRA®',
	'003056A98058':'ROTO-PACKER®',
	'057X1to2Rpm':'1X-2X Rpm',
	'057X2to3Rpm':'2.5X - 3X Rpm',
	'A000Key':'密钥',
	'A001Country':'中文',
	'A002German':'Deutsch',
	'A003English':'English',
	'A004Username':'邮箱',
	'A005Login':'登录',
	'A006Password':'密码',
	'A007RemPassword':'保持登录状态',
	'A008Login':'登录',
	'A009Logout':'退出',
	'A010Production':'生产率',
	'A011Availability':'可用率',
	'A012Maintenance':'设备维护',
	'A013RemainingUnits':'剩余件数',
	'A014ProductionTime':'总时间',
	'A015ProductionTodayGeneral':'今日产量',
	'A015ProductionToday':'今日产量',
	'A016Units':'件',
	'A017RemProduction':'总产量',
	'A018LastReset':'最近重置',
	'A019Faults':'今日中断',
	'A019FaultsBatch':'中断',
	'A020Count':'次',
	'A021FaultDuration':'今日故障时长',
	'A022Minutes':'分钟',
	'A023BagCounterPerFS':'今日计数',
	'A023BagCounterPerFSBatch':'计数',
	'A024FillingStation':'灌装站',
	'A025FSDifference':'计数器扩展',
	'A026AtLeast1Caps':'至少1个大写字母',
	'A026FSworstspout':'有故障的出料嘴',
	'A027Percent':'百分比',
	'A028RejectionsToday':'今日剔除数',
	'A028RejectionsTodayBatch':'今日剔除数',
	'A029FilterStop':'收尘设备',
	'A030RotaryDriveStop':'ROTO-PACKER®',
	'A031ProductFeedStop':'缺料',
	'A032RadimatStop':'RADIMAT®',
	'A033PalletizerStop':'码垛机',
	'A034CompAirFault':'压缩空气',
	'A035TypeChange':'更换品种',
	'A035TypeChangeBatch':'更换品种',
	'A036ProductionRate':'生产率',
	'A037SpeedRelated':'包 / 小时',
	'A038UnitsPerHour':'件 / 小时',
	'A039GoodWeights':'合格产品',
	'A040ScissorHose':'剪刀阀软管',
	'A041ConnectingHose':'连接软管',
	'A042ConeGasket':'锥阀密封',
	'A043AerationPlates':'充气板',
	'A043ScissorHose':'剪刀阀软管',
	'A044ConnectingHose':'连接软管',
	'A044RegulationValve':'流化气调节阀',
	'A045ConeFeeding':'锥阀给料',
	'A045ConeGasket':'锥阀密封',
	'A046AerationPlates':'充气板',
	'A046BagTransBelt':'楔带输送机',
	'A047BagTransBearing':'输送机轴承',
	'A047RegulationValve':'调节阀',
	'A048ConeFeeding':'锥阀给料',
	'A048SuctionCup':'吸盘',
	'A049BagTransBelt':'传输皮带',
	'A049BagTransCyl':'送袋气缸',
	'A050BagTransBearing':'轴承',
	'A050SucRailCyl':'吸袋气缸',
	'A051SuctionCup':'吸盘',
	'A051VacuumPump':'真空泵',
	'A052BagTransCyl':'送袋气缸',
	'A052BagTransCylinde':'送袋气缸',
	'A052CableHightAdj':'高度调节电缆',
	'A053HullMinSensor':'感应器',
	'A053SucRailCyl':'吸袋气缸',
	'A053SucRailCylinder':'吸袋气缸',
	'A054Last48Hours':'持续48小时',
	'A054VacuumPump':'真空泵',
	'A055CableHightAdj':'干燥的压缩空气',
	'A055Last14Days':'持续14天',
	'A056HullMinSensor':'活塞式鼓风机',
	'A056off':'关闭',
	'A057InOperation':'使用中',
	'A058Faulty':'故障',
	'A059InMaintenance':'维护中',
	'A060HourlyValues':'产能 / 小时',
	'A061DischargesTotal':'总出包',
	'A062CreationDate':'创建日期',
	'A062Period':'期间',
	'A063To':'至',
	'A064BatchValue':'品种数值',
	'A064DailyValue':'每日数值',
	'A064DailyValues':'每日数值',
	'A065supply':'供应',
	'A066Transport':'运输',
	'A067Feeding':'给料',
	'A068PackagesMissing':'无包装材料',
	'A069NoHistoricalData':'在此期间无历史数据',
	'A070And':'和',
	'A071Available':'准备就绪',
	'A072ReallyReset':' 确定重置？',
	'A073Details':'详情',
	'A074General':'总况',
	'A075Machines':'设备',
	'A076Dashborad':'仪表板',
	'A077Administration':'管理',
	'A078UserRoles':'用户 & 职位',
	'A079Companies':'公司',
	'A080Machines':'设备',
	'A081Date':'日期',
	'A082Transport':'运输',
	'A083Containermissing':'包装材料缺失',
	'A084Availability':'可用率',
	'A085TypeChanges':'今日更换品种',
	'A086EmptyRejects':'今日空袋剔除数',
	'A086EmptyRejectsBatch':'今日空袋剔除数',
	'A087FullRejects':'今日满袋剔除数',
	'A087FullRejectsBatch':'今日满袋剔除数',
	'A088OpRelease':'允许开始中',
	'A089ProdFeedStop':'停止给料',
	'A090AuxDrive':'辅助驱动器',
	'A091Consumables':'易耗品',
	'A092DischLineStop':'输送线停止',
	'A093TypeChange':'更换品种',
	'A094DailyProduction':'今日产量',
	'A094DailyProductionBatch':'产量',
	'A095Energy':'能量',
	'A096EffectivePower':'有效功率',
	'A097ApparentPower':'视在功率',
	'A098CompAirFlow':'压缩空气流速',
	'A099ResetFailed':'重置失败',
	'A1000Spanish':'Español',
	'A1000UploadMaintenanceAid':'上传维护辅助工具',
	'A1001UploadMaintenanceAidSuccess':'维护帮助已成功上传',
	'A1002UploadMaintenanceAidFailure':'上传维护辅助工具时出错',
	'A1005MachineServiceRequest':'服务请求',
	'A1006RequestService':'请求服务',
	'A1007ServiceContract':'服务合约',
	'A1008ServiceRequestSuccesful':'服务请求已成功处理',
	'A1009ServiceRequestFailure':'服务请求出错',
	'A100AcessDenied':'访问被拒绝',
	'A100AlertmailSubject':'QSI警报：设备名称',
	'A1010LogBook':'日志',
	'A1011CreateLogBook':'创建日志条目',
	'A1012EditLogBook':'编辑日志条目',
	'A1013LogBookItemType':'日志条目类型',
	'A1014LogBookItem':'日志条目',
	'A1015LogBookItemSaved':'已保存日志条目',
	'A1016ErrorInSavingLogBookItem':'保存日志条目时出错',
	'A1017ErrorInRetrievingLogBookItem':'检索日志时出错',
	'A1018ErrorInDeletingLogBookItem':'删除日志条目时出错',
	'A1019LogBookItemDeleted':'日志条目已删除',
	'A101MailSalutation':'你好，USER_NAME,',
	'A101ResetSuccessful':'Métrica foi redefinida',
	'A1020LogBookItemIsDone':'完成',
	'A1021LogBookItemType':'条目类型',
	'A1022ServiceEmail':'服务邮箱',
	'A1023CannotMakeServieRequest':'您无法请求服务，因为此设备没有任何服务电子邮件',
	'A1024MaxUsers':'最大用户数',
	'A1024MaxUsersReached':'已达到公司的最大用户数限制',
	'A1025AtLeast8Characters':'至少8个字符',
	'A1027AtLeast1Lowercase':'至少1个小写字母',
	'A1028AtLeast1Number':'至少1个数字（0-9）',
	'A1029AtLeast1SpecialChar':'至少一个特殊字符（！，。[]）',
	'A102CompanyAddressNewtec':'NEWTEC BAG PALLETIZING <br>32 avenue de Suisee <br>ZI Ile Napoléon - BP 256 <br>68315 Illzach cedex - France',
	'A102CompanyAddressAventus':'AVENTUS GmbH & Co. KG <br>Katzheide 33 <br>D-48231 Warendorf <br>Germany / Deutschland',
	'A102CompanyAddressNiagaraCanada':'HAVER & BOECKER Niagara Canada <br>225 Ontario St. <br>St. Catharines, ON, L2R 7B6 <br>Canada',
	'A102CompanyAddressNiagaraChile':'HAVER & BOECKER Andina <br>Av. El salto 4001, piso 7, of. 71 Comuna Huechuraba <br>8580641 – Santiago <br>Chile',
	'A102CompanyAddressNiagaraBrazil':'HAVER & BOECKER NIAGARA Latinoamericana <br>Av. Dra. Celia Marli S. Salgado Matos, 192 <br>Pedro Leopoldo - MG - 33600-000 <br>Brazil',
	'A102CompanyAddressNiagara':'HAVER & BOECKER NIAGARA <br>Robert-Bosch-Straße 6 <br>D-48153 Münster <br>Germany / Deutschland',
	'A102CompanyAddressFeige':'Feige FILLING GmbH <br> Rogen 6a <br> D-23843 Bad Oldesloe <br> Germany / Deutschland',
	'A102CompanyAddressH_B':'HAVER & BOECKER OHG <br>Carl-Haver-Platz 3 <br>D-59302 Oelde <br>Germany / Deutschland',
	'A102CompanyAddressBehnBates':'Behn Bates Maschinenfabrik GmbH & Co. KG <br> Robert-Bosch Str. 6 <br> 48153 Münster <br> Germany',
	'A102CompanyEmailAventus':'hotline@aventus.global',
	'A102CompanyEmailNiagaraCanada':'info@haverniagara.ca',
	'A102CompanyEmailNiagaraChile':'haverandina@haverniagara.cl',
	'A102CompanyEmailNiagaraBrazil':'info@haverniagara.com.br',
	'A102CompanyEmailNiagara':'info@haverniagara.com',
	'A102CompanyEmailNewtec':'service@newtecbag.com',
	'A102CompanyEmailFeige':'hotline@feige.com',
	'A102CompanyEmailH_B':'hotline@haverboecker.com',
	'A102CompanyEmailBehnBates':'service@behnbates.com',
	'A102CompanyPhoneNumberNewtec':'Phone: +33 389633753',
	'A102CompanyPhoneNumberFeige':'Phone: +49 4531 89 09 222',
	'A102CompanyPhoneNumberAventus':'Phone: +49 2581 4591 2222',
	'A102CompanyPhoneNumberNiagaraCanada':'Phone: +1 800-325-5993',
	'A102CompanyPhoneNumberNiagaraChile':'Phone: +56 (2) 2307-0440',
	'A102CompanyPhoneNumberNiagaraBrazil':'Phone: +55 (31) 3661-1371',
	'A102CompanyPhoneNumberNiagara':'Phone: +49 251 9793 164',
	'A102CompanyPhoneNumberH_B':'Phone: +49 2522 30 371 ',
	'A102CompanyPhoneNumberBehnBates':'Phone: +49 251 979- 0',
	'A102CompanyWebsiteNewtec':'www.newtecbag.com',
	'A102CompanyWebsiteFeige':'www.feige.com',
	'A102CompanyWebsiteAventus':'www.aventus.global',
	'A102CompanyWebsiteNiagaraCanada':'https://haverniagara.com',
	'A102CompanyWebsiteNiagaraChile':'https://haverniagara.com',
	'A102CompanyWebsiteNiagaraBrazil':'www.brazilniagara.com',
	'A102CompanyWebsiteNiagara':'www.haverniagara.com',
	'A102CompanyWebsiteH_B':'www.haverboecker.com',
	'A102CompanyWebsiteBehnBates':'www.behnbates.com',
	'A102MailContent':'<p>There occured an alert in one of your machines: <br> <br>Machine name: <b>MACHINE_NAME</b> <br>Alert message: <b>ALERT_TYPE</b> <br> Machine link:  <a href=\"MACHINE_LINK_TO_DETAIL\">MACHINE_LINK</a> <br> Alert value: ALERT_VALUE_TEXT <em>ALERT_VALUE_SUMMARY  </em><br> Alert time: ALERT_TIME_TEXT<br>ALERT_TIP</p><p>您的某台机器发生警报：<br> <br>机器名称：<b>MACHINE_NAME</b> <br>警报消息：<b>ALERT_TYPE</b> <br>机器链接：<a href=\"MACHINE_LINK_TO_DETAIL\">MACHINE_LINK</a> <br>警报值：ALERT_VALUE_TEXT <em>ALERT_VALUE_SUMMARY</em> <br>警报时间：ALERT_TIME_TEXT<br>ALERT_TIP</p><p style=\'font-size: 12px;\'>此电子邮件是由于您在 <a href=\'TYP_WEBSITE\' style=\'text-decoration: none; font-color: blue;\'>TYP_WEBSITE</a> 订阅而自动生成的。要取消订阅，请登录该页面，然后在菜单 <b>警报</b> 下方选择 <b>设置</b>。</p> <br>请不要回复此邮件。如有疑问，请联系<a href=\"mailto:COMPANY_EMAIL\">COMPANY_EMAIL</a>。 <br> <br></p><p style=\'font-size: 12px;\'>电子邮件自动发送 <a href=\'TYP_WEBSITE\' style=\'text-decoration: none;字体颜色：蓝色；\'>TYP_WEBSITE</a> 通用。 Zum Beenden des Abos loggen Sie sich auf der Seite ein and klicken unter <b>Alarmmeldungen</b> auf den Menüpunkt <b>Einstellungen</b>。 <br>Bitte Antworten Sie nicht auf diese Mail。如有任何疑问，请联系<a href=\"mailto:COMPANY_EMAIL\">COMPANY_EMAIL</a>。<br><br></p><p>此致，<br><br>公司地址<br><br>公司电话号码<br>电子邮件：<a href=\"mailto:COMPANY_EMAIL\">COMPANY_EMAIL</a><br>网站：<a href=\'COMPANY_WEBSITE\'>COMPANY_WEBSITE</a><br><small style=\"color:white;\">警报源 ID：ALERT_SOURCE_ID</small></p>',
	'A102TypeChanges':'今日产品切换',
	'A102TypeChangesBatch':'今日产品切换',
	'A102TYPWebsite':'https://trackyourplant.com',
	'A1030Description':'描述',
	'A103EndOfBatch':'最后一批',
	'A103ResetmailSubject':'重置：设备名称',
	'A104FullPalletCount':'满垛',
	'A104ResetMailContent':'<p>The occurred alert is resolved: </p><p>Machine name: <b>MACHINE_NAME</b><br>Alert message: <b>ALERT_TYPE</b><br>Machine link: MACHINE_LINK<br><p style=\'font-size: 12px;\'>This e-mails was generated automatically because of a <p>已解决的警报：</p><p>机器名称：<b>MACHINE_NAME</b><br>警报消息：<b>ALERT_TYPE</b><br>机器链接：MACHINE_LINK<br><p style=\'font-size: 12px;\'>此电子邮件由 <a href=\'TYP_WEBSITE\' style=\'text-decoration: none; font-color: blue;\'>TYPE_WEBSITE</a> 的订阅自动生成。要取消订阅，请登录该页面，并在菜单 <b>警报</b> 下方选择 <b>设置</b>。</br>请勿回复此邮件。如有疑问，请联系 COMPANY_EMAIL。</p><p style=\'font-size: 12px;\'>此电子邮件由 <a href=\'TYP_WEBSITE\' style=\'text-decoration: none; font-color: blue;\'>TYP_WEBSITE</a> 已生成。要取消订阅，请登录网站并点击“提醒消息”下的“设置”菜单项。<br>请勿回复此邮件。如有任何疑问，请联系 COMPANY_EMAIL。</p><p>此致，<br>COMPANY_ADDRESS<br></p><p>COMPANY_PHONE_NUMBER<br>电子邮件：COMPANY_EMAIL<br>互联网：COMPANY_WEBSITE <br></p><small style=\"color:white;\">提醒源 ID：ALERT_SOURCE_ID</small>',
	'A105ConnectivityMailSubject':'连接错误：设备名称',
	'A105LoadEmptyPallets':'空托盘进给',
	'A106Fillings':'填充',
	'A106PLCMailSubject':'PLC 警报：设备名称',
	'A107FillingsPerHour':'填充率 / 时',
	'A107PLCResolvedMailContent':'575<p>以下警报已在机器 MACHINE_NAME 上解决：。<br><br>警报类型<br><br>机器链接<br><br>此电子邮件由<a href=\'TYP_WEBSITE\' style=\'text-decoration: none; font-color: blue;\'>TYP_WEBSITE</a>订阅自动生成。要取消订阅，请登录该页面，并在菜单<b>警报</b>下方选择<b>设置</b>。<br><p>请勿回复此邮件。如有任何疑问，请联系 COMPANY_EMAIL。</p><br><br>此致，<br><br>公司地址<br><br>公司电话号码<br>电子邮件：COMPANY_EMAIL<br>互联网：COMPANY_WEBSITE',
	'A108Availability':'可用率',
	'A108AvailabilityMailSubject':'可用率警报：MACHINE_NAME',
	'A109FillingsRemain':'灌装剩余',
	'A110StartOfOrder':'批次处理开始时间',
	'A111ProductID':'产品批号',
	'A112TargetWeight':'目标重量',
	'A113Kg':'公斤',
	'A114CurrentOrder':'当前订单',
	'A115FillingCount':'当前批次',
	'A116CycleTime':'设备循环时间',
	'A117Total':'总共',
	'A118CentreStation':'中心处理站',
	'A119N2Station':'氮气站',
	'A120FillingStation':'灌装站',
	'A121SealingStation':'封口站',
	'A122Seconds':'秒',
	'A123FaultLength':'设备故障',
	'A124Minutes':'分钟',
	'A124Minute':'分钟',
	'A125ExtFaultLength':'外部故障',
	'A126FillingCount':'灌装总数',
	'A127WithinTolerance':'误差范围内的灌装',
	'A128OutsideTolerance':'误差范围外的灌装',
	'A129BagManufacture':'合格产品',
	'A130BagsPerHour':'包 / 小时',
	'A131BagQuality':'袋子质量',
	'A132CorrPlacedbags':'正确插好的袋子',
	'A133TwoAttempts':'尝试第2次开袋',
	'A134ThreeAttempts':'尝试第3次开袋',
	'A135DiscardeBags':'废弃的袋子',
	'A136Faults':'中断',
	'A137CompAir':'压缩空气',
	'A138ProductFeed':'物料供给 （称重）',
	'A139EmptyBagMag':'空袋仓',
	'A140Separation':'分离',
	'A141Vacuum':'真空 ',
	'A142FillingStation':'灌装站',
	'A143FullBagTransport':'满袋输送',
	'A144BagSealing':'封口',
	'A145Disrupt':'干扰',
	'A145AccessDoor':'检修门',
	'A145DSafetyLightBarrier':'安全光柵',
	'A145UpstreamSupply':'上游供应',
	'A145EmergencyStop':'急停开关',
	'A146BunChangeAbs':'总共更换小车次数',
	'A147BunChangeToday':'今日更换小车次数',
	'A147BunChangeTodayBatch':'今日更换小车次数',
	'A148BagsPerBundle':'每车可容纳的包装袋数量',
	'A149TypeChanges':'今日更换品种',
	'A149TypeChangesBatch':'更换品种数量',
	'A150FillingTime':'灌装时间',
	'A151DosingUnit1':'物料供给',
	'A152DosingUnit2':'物料供给2',
	'A153AerInletBox1':'进料入口充气',
	'A154AerInletBox2':'进料入口充气2',
	'A154DosingUnit1':'物料供给',
	'A155DosingUnit2':'物料供给2',
	'A155RotaryDrive':'旋转驱动器',
	'A156AerInletBox1':'进料入口充气',
	'A156DischargeBelt':'卸包皮带',
	'A157AerInletBox2':'进料入口充气2',
	'A157AlignmentBelt':'顺包机',
	'A158BagCleaning':'清包机',
	'A158RotaryDrive':'旋转驱动器',
	'A159AccelerationBelt':'加速皮带',
	'A159DischargeBelt':'卸包皮带',
	'A160AlignmentBelt':'顺包机',
	'A160CheckBelt':'复检称皮带',
	'A161BagCleaning':'清包机',
	'A161FlatBelt':'平皮带输送机',
	'A162AccelerationBelt':'加速皮带',
	'A162RejectionBelt':'剔包机皮带',
	'A163CheckBelt':'复检称皮带',
	'A163RejectionDrive':'剔包机提升驱动器',
	'A164FlatBelt':'平板输送皮带',
	'A164RotaryCutter':'破包机',
	'A165RejectionBelt':'剔包机皮带',
	'A165ScreenDrum':'振动筛毂',
	'A166RejectionDrive':'剔包机提升驱动器',
	'A166Welding':'焊封装置',
	'A167Cutter':'切刀',
	'A167RotaryCutter':'破包机',
	'A168ScreenDrum':'分离机',
	'A168SuctionCup':'吸盘',
	'A169Brakes':'刹车',
	'A170VacuumPump':'真空泵',
	'A171Filter':'过滤空气',
	'A172BagDisConveyor':'袋分配输送机',
	'A173BagTurnConveyor':'转位输送机',
	'A174BagTurnCross':'转包十字架',
	'A175BagDisConveyor':'袋分配输送机',
	'A175BagTurnClamp':'转位夹具',
	'A176BagTurnConveyor':'转位输送机',
	'A176GroupingBelt':'编组输送机皮带',
	'A177BagTurnCross':'转包十字架',
	'A177RowPusher':'推袋器',
	'A178DoubleStripPlate':'双推袋板',
	'A179ConformingPlate':'对中板',
	'A179GroupingBelt':'编组输送机皮带',
	'A180GantrySafety':'起重机架安全开关',
	'A180RowPusher':'推袋器',
	'A181DoubleStripPlate':'双推袋板',
	'A181Gantry':'起重机架',
	'A182ConformingPlate':'对中板',
	'A182PalletAlignment':'空托盘对齐装置',
	'A183GantrySafety':'起重机架安全开关',
	'A183PalletRoller1':'托盘滚筒输送机',
	'A184Gantry':'起重机架',
	'A184PalletDispenser':'空托盘分配器',
	'A185PalletAlignment':'空托盘对齐装置',
	'A185PalletRoller2':'托盘滚筒输送机',
	'A186PalletRoller1':'托盘滚筒输送机',
	'A186PalletRoller3':'托盘滚筒输送机',
	'A187CyclesChain':'链条',
	'A187PalletDispenser':'空托盘分配器',
	'A188BundlePusher':'推垛气缸',
	'A188PalletRoller2':'托盘滚筒输送机',
	'A189BundlePartition':'推袋气缸',
	'A189PalletRoller3':'托盘滚筒输送机',
	'A190BagLifter':'提袋气缸',
	'A190CyclesChain':'链条',
	'A191BundlePusher':'推垛气缸',
	'A191PressRolls':'整形气缸',
	'A192BundlePartition':'分离气缸',
	'A192OpeningStation':'开口站气缸',
	'A193BagApplicator':'插袋机气缸',
	'A193BagLifter':'提袋气缸',
	'A194BagSupport':'袋支撑气缸',
	'A194PressRolls':'压辊气缸',
	'A195OpeningStation':'开口站气缸',
	'A195Pusher':'推袋气缸',
	'A196BagApplicator':'插袋机气缸',
	'A196StretchPliers':'拉伸钳气缸',
	'A197BagSupport':'袋支撑气缸',
	'A197FillingStation':'灌装站气缸',
	'A198FilledBagGripper':'满袋抓手气缸',
	'A198Pusher':'推袋气缸',
	'A199StretchPliers':'拉伸钳气缸',
	'A199SucBagSeperation':'袋分离站吸盘',
	'A200FillingStation':'灌装站气缸',
	'A200SucOpenStation':'开口站吸盘',
	'A201FilledBagGripper':'满袋抓手气缸',
	'A201Remaininghours':'剩余时间',
	'A202PriceTotal':'合计',
	'A202SucBagSeperation':'取袋吸盘',
	'A203RemainingNumberFillings':'剩余填充量',
	'A203SucOpenStation':'开口站吸盘',
	'A204SafetyDoor':'安全门开关',
	'A205SafetyLightBarrier':'光栅',
	'A206BagTransport':'袋输送装置',
	'A207EmptyPalletTrans':'空托盘仓',
	'A208Palletizer':'码垛机',
	'A209FullPalletTrans':'满袋托盘输送',
	'A210NumberTodayPiece':'今天包装量 ',
	'A211Programme':'程序',
	'A212Efficiency':'效率',
	'A213Loginsuccessful':'登录成功',
	'A214CurrentPerformance':'当前运行状态',
	'A215CyclesToday':'今日循环量',
	'A215CyclesTodayBatch':'今日循环量',
	'A216RejectsToday':'今日剔除量',
	'A216RejectsTodayBatch':'今日剔除量',
	'A217MetalDetectorToday':'今日金属检测量',
	'A217MetalDetectorTodayBatch':'今日金属检测量',
	'A218BrokenBagsToday':'今日破袋检测量',
	'A218BrokenBagsTodayBatch':'今日破袋检测量',
	'A219FaultPerShift':'当前批次',
	'A220FaultBagManufacture':'制袋',
	'A221FaultBagFilling':'袋填充',
	'A222FaultBagTransport':'袋运输',
	'A223FaultSealing':'封口',
	'A224FaultWeigher':'灌装站',
	'A225FaultPeriphery':'其他外界因素',
	'A226Shift':'班次',
	'A227Container':'包装材料',
	'A228Hours':'小时',
	'A229NoPackage':'无包装材料',
	'A230NoProduct':'无物料',
	'A231NoOutlet':'无卸包',
	'A232GoodPerformance':'生产',
	'A233GoodWeights':'合格包',
	'A234NotPlacedBags':'没插好的袋子',
	'A234NotPlacedBagsAutomatic':'自动没插好的袋子',
	'A235CollectiveFaultsToday':'总故障',
	'A235CollectiveFaultsTodayBatch':'总故障',
	'A236Applicator':'插袋机',
	'A237NetWeigher':'净重称',
	'A238IncorrectWeight':'重量不合格包',
	'A239Hours':'小时',
	'A240QrCode':'QR码',
	'A241OpenBags':'开袋',
	'A242FaultCheckWeigher':'复检称',
	'A243DashboardAllMachines':'仪表板 / 所有设备',
	'A244DashboardState':'状态',
	'A245DashboardMachineStateRunning':'开启',
	'A246DashboardMachineStateOffline':'关闭',
	'A247DashboardMachineStateMaintenance':'必要维护',
	'A248DashboardMachineStateError':'错误',
	'A249SortChangeToday':'今日更换品种',
	'A249SortChangeTodayBatch':'更换品种数量',
	'A250EmptyBagMagazineToday':'袋仓补袋',
	'A250EmptyBagMagazineTodayBatch':'袋仓补袋',
	'A251FaultCheckWeigher':'今日故障',
	'A252IVTSTOP':'INTEGRA®',
	'A253N/A':'无',
	'A254CyclePumpFS1':'循环泵 FS 1',
	'A255CyclePumpFS2':'循环泵 FS 2',
	'A256CyclePumpFS3':'循环泵 FS 3',
	'A257ConHoseFS1':'连接软管 FS 1',
	'A258ConHoseFS2':'连接软管 FS 2',
	'A259ConHoseFS3':'连接软管 FS 3',
	'A260InfSleeveFS1':'膨胀套管 FS 1',
	'A261InfSleeveFS2':'膨胀套管 FS 2',
	'A262InfSleeveFS3':'膨胀套管 FS 3',
	'A263BundlePusher':'推垛装置',
	'A264VacuumUnit':'真空单元',
	'A265TravellingDrive':'横走装置',
	'A266CenteringUnit':'对中装置',
	'A267EmptyBagMagazine':'空袋仓',
	'A268BeltPlant':'皮带设备',
	'A269IvtTurbine':'灌装叶轮',
	'A270IvtTripSaddle':'倾卸袋座',
	'A271IvtCoarseFeed':'粗喂料',
	'A272IvtBagHolder':'压袋装置',
	'A273IvtFillBoxAir':'充气箱盖',
	'A274IvtFillChanAir':'环形充气',
	'A275IvtInflSleeve':'膨胀套管',
	'A276IvtInletBoxAir':'进料入口充气',
	'A277IvtFillTubeBlow':'料嘴吹出',
	'A278IvtOutlChanAir':'灌装通道出口',
	'A279IvtPusher':'推袋装置',
	'A280IvtSaddleHeight':'袋座高度调节',
	'A281IvtCloseAnvil':'砧条合上',
	'A282IvtBagSeal':'焊封装置',
	'A283IvtFineFeedAdj':'精喂料调整',
	'A284Interrupts':'中断',
	'A284InterruptsGeneralPage':'中断',
	'A284InterruptsBatch':'中断',
	'A285BagCounterShift':'每班计数',
	'A286WrongBags':'没插好的袋子',
	'A287ReelChanges':'更换滚筒',
	'A287ReelChangesBatch':'更换滚筒',
	'A288VibrationDuration':'延长振动时间',
	'A289Total':'总共',
	'A290HopperMin':'最小料仓容积',
	'A291ManualActivation':'手动激活',
	'A292FillingRelease':'开始填充',
	'A293EGF':'EGF®',
	'A294PalletTrasport':'托盘输送',
	'A295SafetyCircuit':'安全线圈',
	'A296FltCompAir':'今日压缩空气故障',
	'A296FltCompAirBatch':'今日压缩空气故障',
	'A297StrokesPump':'今日泵停顿时间',
	'A297StrokesPumpBatch':'今日泵停顿时间',
	'A298MaxStrokeDur':'今日最大暂停时间',
	'A298MaxStrokeDurBatch':'今日最大暂停时间',
	'A299AvgStrokes':'今日每包平均停顿时间',
	'A299AvgStrokesBatch':'今日每包平均停顿时间',
	'A300InternalPressure':'内部气压',
	'A301Max':'最大',
	'A301MessageAdministration':'信息中心',
	'A302ErrorNumber':'错误次数',
	'A302Millibar':'小电控柜',
	'A303ActivateAlertMail':'警告邮件激活',
	'A303SetValueMax':'最大价值设置',
	'A304AlertText':'警示文本',
	'A304SetValueMin':'最小价值设置',
	'A305ActivateResolvedMail':'已解决问题邮件激活',
	'A305SetValueChanged':'您的设置已保存',
	'A305SetValueChangedRefreshWindow':'你的修改已被保存。刷新浏览器窗口后，更改将可见',
	'A306KW':'kW',
	'A306Resolved Text':'故障解除文本',
	'A306ResolvedText':'故障解除文本',
	'A307AddMessage':'信息',
	'A307KVA':'kVA',
	'A308EditMessage':'信息编辑',
	'A308Nm3PerH':'Nm³/h',
	'A309KWH':'kWh',
	'A310NM3':'Nm³',
	'A311CompAirVol':'耗气量',
	'A312ActiveEnergy':'能耗',
	'A313ReactivePower':'功率',
	'A314ChartConfiguration':'配置',
	'A315SetDateValueMax':'最长日期设置',
	'A316SetDateValueMin':'最短日期设置',
	'A317InvalidData':'无效数据',
	'A318DeleteUser':'确定删除该用户？',
	'A319EnterAllFields':'请填写数据',
	'A320EnterValidEmail':'请输入有效邮箱地址',
	'A321DeleteCompany':'确认删除该公司名?',
	'A322CouldNotDeleteUser':'管理员无法删除，请先变更至普通用户',
	'A323LoginSuccess':'登录成功',
	'A324Selected':'选择',
	'A325Total':'总共',
	'A326Reset':'重置',
	'A327Reporting':'报告',
	'A328ReportingActive':'激活',
	'A329ReportingActiveHelpPrefix':'激活时将被生成常规报告',
	'A330ReportingActiveHelpSuffix':'发送',
	'A331ReportingFrequency':'频率',
	'A332ReportingFrequencyDaily':'每天',
	'A333ReportingFrequencyWeekly':'每周',
	'A334ReportingFrequencyMonthly':'每月',
	'A335ReportingDynContent':'动态内容',
	'A336ReportingDynContIncludeElapsedMI':'维护间隔已过期',
	'A337ReportingLanguage':'语言',
	'A338ReportingProdDayEnd':'停止生产',
	'A339ReportingFirstReport':'第一封报告时间',
	'A340CardCtxMenuReport':'包含在报告里',
	'A341CardCtxMenuHistoReport':'报告里包含柱状图',
	'A342CardCtxMenuReset':'计数重置',
	'A343CardCtxMenuSettings':'设置',
	'A344CardLabelReport':'报告',
	'A345CardLabelHistoReport':'柱状图报告',
	'A346CardLabelMaintenReport':'维护报告',
	'A347ReportSettings':'设置',
	'A348Alerting':'警示 ',
	'A349AlertingSettings':'设置',
	'A350AlertingActive':'激活',
	'A351AlertingActiveHelpPrefix':'激活时将会发送警示报告',
	'A352AlertingActiveHelpSuffix':'以下可选择的警示信息',
	'A353AlertingTypes':'警示',
	'A354AlertTypeMainten':'维护间隔已过：',
	'A355AlertTypeAvail':'生产能力',
	'A356AlertTypePLC':'PLC',
	'A357AlertTypeConError':'连接错误',
	'A358DeleteAdminUser':'管理员不能被删除',
	'A359MaintAids':'维护助手',
	'A360MaintInt':'维护中断',
	'A361ChooseMaschine':'选择设备',
	'A362Video':'视频',
	'A363InstructionManual':'操作说明书',
	'A364ExplodedviewDrawing':'防爆图纸',
	'A364SparePartCatalog':'备件图册',
	'A365OpenVideoHelp':'打开视频帮助',
	'A366OpenInstructionManual':'打开操作手册',
	'A367OpenExploadedView':'打开防爆视图',
	'A368ResetMaschineData':'设备数据重置',
	'A369BotWeld':'底部焊封',
	'A370BotWeldTef':'特氟隆底部焊封',
	'A371TopWeld':'顶部焊封',
	'A372TopWeldTef':'特氟隆顶部焊封',
	'A373LeftWeld':'左边角封',
	'A374LefWeldTef':'特氟隆左边角封',
	'A375RigWeld':'右边角封',
	'A376RigWeldTef':'特氟隆右边角封',
	'A377CutKnife':'切刀',
	'A378ReallyClearReport':'此操作会将报告里的所有项删除，而且不能恢复，请确定是否需要删除？',
	'A379ProdCurrShift':'当前生产批次',
	'A380ReallyDeleteItemReport':'此操作会将报告里的所有项删除，而且不能恢复，请确定是否需要删除？',
	'A380TypeCurrent':'当前品种',
	'A381SampleBags':'剔除的取样袋包数',
	'A382OpenBags':'剔除的袋子开口的包数',
	'A383IncorrectBags':'剔除的重量不合格包数',
	'A384NotPlacedBagsMan':'手动没插好的袋子',
	'A385Spout1':'维护 灌装站1',
	'A386LastUpdate':'最近更新：',
	'A386Spout2':'维护 灌装站2',
	'A387Spout3':'维护 灌装站3',
	'A388Spout4':'维护 灌装站4',
	'A389LastUpdate':'最近更新：',
	'A390FilledBagTrans':'满袋输送',
	'A391ConveyerSystem':'卸包皮带',
	'A392BeltBundleTrans':'输送皮带',
	'A393BagHolderBuffer':'压袋头',
	'A394SlidePlates':'闸板',
	'A395ImpellerShaft':'叶轮轴组件',
	'A396ShaftAssembly':'下部轴组件',
	'A397ThreePosCylinder':'三位气缸',
	'A398DateFormatNoSeconds':'YYYY.MM.DD h:mm',
	'A399DateFormat':'YYYY.MM.DD h:mm:ss ',
	'A399DateFormatAngularPipe':'yyyy.MM.dd h:mm:ss ',
	'A400ConveyorSystem':'输送系统',
	'A400History':'历史',
	'A401ReportHistory':'历史报告',
	'A402ReportId':'ID报告',
	'A403ReportGeneratedTime':'报告生成时间',
	'A404DosingFeeder':'计量给料装置',
	'A404ReportGeneratedBy':'报告生成者',
	'A405DownloadReport':'下载报告',
	'A406TriggeredHistoryReport':'报告生成开始',
	'A407ViewReport':'查看报告',
	'A408BagHolder':'压袋装置',
	'A408BagHolder ':'压袋装置',
	'A414BundleTransport':'送垛装置',
	'A415HoistingDevice':'升降装置',
	'A416PlacerArm':'插袋手臂',
	'A417CrossProcess':'横走装置',
	'A418OpeningStation':'开口站',
	'A421Claw':'抓袋装置',
	'A422WeightData':'平均值',
	'A423StdDevData':'标准差',
	'A430kg':'公斤',
	'A431lb':'磅',
	'A432t':'吨',
	'A433klb':'千磅',
	'A434g':'克',
	'A435BagManufacture':'制袋',
	'A436Aux_Pump':'真空泵',
	'A437TopWelding':'顶部焊封',
	'A438PunchingDeviceWelding':'焊封撞击装置',
	'A439Aux_Vibrator1':'振动装置 1 ',
	'A440Aux_Vibrator2':'振动装置 2',
	'A441Aux_Vibrator3':'振动装置 3',
	'A442Truck_Loading':'装车机',
	'A443Truck_Available':'今日无卡车',
	'A444FS1':'灌装站 1',
	'A445FS2':'灌装站 2',
	'A446FS3':'灌装站 3',
	'A447FS4':'灌装站 4',
	'A448FS5':'灌装站 5',
	'A449FS6':'灌装站 6',
	'A450FS7':'灌装站 7',
	'A451FS8':'灌装站 8',
	'A452FS9':'灌装站 9',
	'A453FS10':'灌装站 10',
	'A454FS11':'灌装站 11',
	'A455FS12':'灌装站 12',
	'A456FS13':'灌装站 13',
	'A457FS14':'灌装站 14',
	'A458FS15':'灌装站 15',
	'A459FS16':'灌装站 16',
	'A460OeeValue':'设备综合效率',
	'A460Oee':'OEE',
	'A460PushAlert':'<h1>警报：ALERT_TYPE</h1><p>机器名称：<b>MACHINE_NAME</b> <br>警报消息：<b>ALERT_TYPE</b>',
	'A461OeeAvailable':'有效性因素',
	'A461PushAlertResolved':'<h1>已解决：ALERT_TYPE</h1><p>机器名称：<b>MACHINE_NAME</b> <br>警报消息：<b>ALERT_TYPE</b>',
	'A462OeePerformance':'运行因素 ',
	'A463DowntimePlaned':'计划检修时间',
	'A464DowntimeMachine':'设备检修时间',
	'A465DowntimeOther':'其他检修时间',
	'A466OperatingFactor':'操作因素',
	'A467Throughput':'生产量因素',
	'A468OeeRejects':'今天剔除量',
	'A469OeeQuality':'质量因素',
	'A470OeeDowntime':'检修时间',
	'A471RejectsTotal':'总共剔除量',
	'A472RejectsIncorrect':'剔除重量错误包',
	'A473RejectsOpen':'剔除未封口包',
	'A474RejectsSample':'剔除样品包',
	'A475RejectsMetal':'金检不合格剔除',
	'A476ConfigTable':'校准',
	'A477OEERowActive':'激活',
	'A478OEEProduction':'生产',
	'A479OEEBreak':'暂停',
	'A480OEEMaint':'维护',
	'A481OEETypeChg':'产品切换',
	'A482OEEOthers':'其他检修时间',
	'A483OEEFrequ':'频率',
	'A484OEEUnique':'唯一',
	'A485OEEDaily':'每天',
	'A486OEEWeekly':'每周',
	'A487Days':'天数',
	'A488Monday':'星期一',
	'A489Tuesday':'星期二',
	'A490Wednesday':'星期三',
	'A491Thursday':'星期四',
	'A492Friday':'星期五',
	'A494Saturday':'星期六',
	'A498Comment':'评论',
	'A495Sunday':'星期日',
	'A496From':'从',
	'A497To':'到',
	'A499TabMachineMessages':'设备信息',
	'A500MMLive':'在线信息',
	'A500VbeltDrive':'包装机转动电机V型皮带',
	'A501MMStatistic':'信息统计',
	'A501VbeltTurbine':'叶轮电机V型皮带',
	'A502Impeller':'叶轮片',
	'A502MMLive':'设备在线信息',
	'A503FillingTube':'灌装料嘴',
	'A503MMStatistic':'设备信息统计',
	'A504BagGuide':'导向板',
	'A504Type':'型号',
	'A505Control':'控制',
	'A505Saddle':'袋鞍',
	'A506BoltBagChair':'推袋椅螺栓',
	'A506Number':'数量',
	'A507BushBagChair':'推袋椅衬套',
	'A507Message':'信息',
	'A508Amount':'数量',
	'A508BearingPusher':'轴承推进器',
	'A509Duration':'持续时间',
	'A509RearSlidePlate':'后置闸板',
	'A510SlideValve':'闸阀',
	'A510TonsPerHour':'吨/小时',
	'A511FrontSlidePlate':'前置闸板',
	'A511Tons':'吨',
	'A512RepairKitSlidePlates':'闸板维修包',
	'A512RPM':'轮/分',
	'A513BagChairChange':'更换退包椅',
	'A513BagTransBeltServo':'伺服橡胶皮带',
	'A514InfeedBelt':'喂料皮带',
	'A515FlattBelt':'平皮带',
	'A516BagTakingBelt':'接包皮带',
	'A517RollerConveyor':'辊式输送机',
	'A518LiftingGantry':'提升机架',
	'A519LinearDrive':'直线型驱动器',
	'A520SwivelJoint':'回转接头',
	'A521LiftingGantry':'辊式输送机提升机架',
	'A522FullPallets':'满托盘辊式输送机',
	'A523EvacConveyor':'出垛输送机',
	'A524SafetyBarrier':'安全光栅',
	'A525BasicCleaning':'基本清洁',
	'A526SafetyDevices':'安全装置',
	'A530CylSucBar':'吸盘气缸关闭',
	'A531FilledBagGripper1':'满袋抓手气缸1',
	'A532FilledBagGripper2':'满袋抓手气缸2',
	'A533CylCutKnife':'切刀气缸',
	'A534CylBotWelding':'袋底焊封气缸',
	'A535SpoutLift':'出料嘴提升',
	'A536CylClampTopWeld':'袋顶焊缝气缸夹具',
	'A537CylTopWeld':'袋顶焊缝气缸',
	'A538CylCornerWeld':'角封气缸',
	'A539AdjHeightDischargebelt':'卸包皮带高度自动调节',
	'A540EmptyBagTransport':'空袋输送',
	'A541Virbator':'振动操作时间',
	'A542CylCoolPlatesCornerWeld':'角封冷却板气缸',
	'A543CylBagGuide':'袋导向板气缸',
	'A544CylClampBotWeld':'袋底焊封气缸夹具',
	'A545CylCoolBotWeld':'袋底冷却气缸',
	'A546CylFilledBagGripper3':'满袋抓手气缸3',
	'A547CylStatBagGripper':'抓手固定气缸',
	'A548CylEmptyBagGripper1':'空袋抓手气缸1',
	'A549CylStretching':'拉伸气缸',
	'A550CylOpenSpout':'开袋气缸',
	'A551CylBagAplicatorLift':'插袋机升降气缸',
	'A552CylStretcherOpen':'拉伸钳气缸打开',
	'A553CylStretcherInwards':'拉伸钳内部气缸',
	'A554FoilTrackingDevice':'膜跟踪装置',
	'A555DischargeBelt2':'卸包皮带BP2操作时间',
	'A556CylStretching':'拉伸装置气缸',
	'A557CylEmptyBagGripper2':'空袋抓手气缸2',
	'A558UnwindingDevice':'滚筒操作时间',
	'A559BagLenghtAdj':'袋长调节',
	'A560CylVibratorLift':'振动提升',
	'A561CylFilmGuide':'膜导向气缸',
	'A562CylPushFlaps':'推板气缸',
	'A563CylWeldReelChanger':'焊缝滚轮',
	'A564CylWeldReelChangerTef':'特氟隆焊缝滚轮',
	'A565DriveReelChanger':'滚轮驱动器',
	'A566DriveAdjCornerWeld':'角封宽度调节驱动器',
	'A567CylThreadingInwards':'螺纹气缸成功向内',
	'A568CylThreadingOutwards':'螺纹气缸成功向外',
	'A569CylThreadingDownwards':'螺纹气缸分离板朝下',
	'A570CylSucRailClose':'吸盘气缸关闭',
	'A571DischargeBelt2':'卸包皮带BP2',
	'A572CylSpoutOpen':'灌装站气缸打开',
	'A573Drives':'驱动器',
	'A574Cylinders':'气缸',
	'A575LowAttrition':'低易损件',
	'A576HighAttrition':'高易损件',
	'A577SetUpTimeAvBatch':'设置时间 Ø',
	'A578SetUpTimeAv':'今天Ø设置时间',
	'A579GrossTimeBatch':'总时间',
	'A580GrossTime':'今天总时间',
	'A581SetUpTime':'设置时间',
	'A582Downtime':'检修时间 ',
	'A583MonthBestPerf':'每月最佳操作',
	'A584PressureChamperSeal':'密封压力仓',
	'A585Aeration':'充气装置',
	'A586SpillageRejector':'溢料回收装置',
	'A587VibrationBottle':'振动瓶',
	'A588VibrationTable':'振动台',
	'A589BagPlacing':'放袋',
	'A590RotaryFeeder':'旋转给料机',
	'A591TopSeamCleaning':'顶缝清洁',
	'A592Beltplant1':'皮带输送机 1',
	'A593Beltplant2':'皮带输送机 2',
	'A594HydraulikPump':'液压泵',
	'A595DriveEBTS':'送空袋驱动',
	'A596HostingEBTS':'送空袋升降装置',
	'A597Ventilator':'通风装置',
	'A598RD':'旋转部分',
	'A599SpoutCoarse':'灌装料嘴粗喂料',
	'A600RotaryGateCoarse':'旋转门粗喂料',
	'A601HostingVIC':'升降装置初始压下',
	'A602SpoutFine':'灌装料嘴精喂料',
	'A603RotaryGateFine':'旋转门精喂料',
	'A604HostingVSC1':'升降装置第2次压下',
	'A605HostingVSC2':'升降装置第3次压下',
	'A606FBTransfer':'满袋输送',
	'A607FBTHost':'满袋搬运',
	'A608FBTswivel':'满袋转动',
	'A609FBTClamp':'满袋夹住',
	'A610FBTransport':'满袋输送',
	'A611FBTransportClamp':'满袋夹住',
	'A612HostBFS':'袋子成形站升降装置',
	'A613SwivelBFS':'袋子成形站转动',
	'A614SideGussetblade':'侧折板',
	'A615HostTopwelding':'顶封升降装置',
	'A616CloseTopWelding':'顶封合上',
	'A617Folding1':'折叠1',
	'A618Folding2':'折叠2',
	'A619Folding3 ':'折叠3',
	'A620PUD':'打孔装置',
	'A621PUDWeld':'焊封打孔装置',
	'A622BeltReject':'丢包装置皮带',
	'A623RejectingDevice':'丢包装置',
	'A624BagLenght':'袋子长度',
	'A624PerfToday':'今日性能',
	'A625PerfTodayBatch':'性能',
	'A626Output':'今日产出',
	'A627OutputBatch':'产出',
	'A628UnitperH':'袋/小时',
	'A629Percent':'%',
	'A630BagJunction':'袋连接板',
	'A631ToothedBelt':'张紧齿形带',
	'A632LevellingFoot':'检查调平脚 RAD',
	'A633PolymerGuide':'聚合物导轨+滚轮',
	'A634BallBushing':'球衬套耦合器',
	'A635ScissorHoseReplace':'剪刀阀软管',
	'A636ConnectingHoseReplace':'连接软管',
	'A637Bellow':'鞍座高度调节电缆',
	'A638TipperFrame':'检查自卸车框架',
	'A639HosePressureChamber':'检查软管压力室',
	'A640FlapFillingBox':'检查翻盖填充盒',
	'A641RotoLock':'ROTO-LOCK®',
	'A642Hours':'小时',
	'A643Temp':'°C',
	'A644Millisecond':'ms',
	'A645KgPerSecond':'kg/s',
	'A646RoundsperMinute':'rpm',
	'A647Meter':'m',
	'A648Millimeter':'mm',
	'A649Cubicmeter':'m³',
	'A650Liter':'l',
	'A651Counts':'件',
	'A652WeldingTemperature':'焊接温度',
	'A653WeldingDuration':'焊接时间',
	'A654FillingSystem':'灌装系统',
	'A655EmailSignature':'电子邮件签名',
	'A656NumberWasteBags':'垃圾袋数量',
	'A657FreqConverter':'频率转换器',
	'A658ServoDrives':'伺服驱动器',
	'A656Voltage':'电压',
	'A657Volt':'V',
	'A658U1':'U1',
	'A659U2':'U2',
	'A660U3':'U3',
	'A661U12':'U12',
	'A662U23':'U23',
	'A663U31':'U31',
	'A664Current':'权力',
	'A665Amps':'A',
	'A666I1':'I1',
	'A667I2':'I2',
	'A668I3':'I3',
	'A669Frequency':'頻率',
	'A670Hertz':'Hz',
	'A671Pressure':'压力',
	'A672Bar':'bar',
	'A673Moisture':'dew point ',
	'A674AirFlowUnit':'m³',
	'A675AnnualConsum':'年度消费',
	'A676MonthlyConsum':'月度消费',
	'A677FreeConsum':'消费量',
	'A678PowerEfficiency':'功率效率',
	'A679BagsPerKWH':'袋子 / kWh',
	'A681SinceReset':'由于复位',
	'A682LastTimeSortUse':'自上次使用以来',
	'A683SortNumber':'品种编号',
	'A684Overall':'总的来说',
	'A685AirEfficiency':'空气效率',
	'A686BagsPerAirFlowUnit':'每袋 m³',
	'A687Jan':'1月',
	'A688Feb':'2月',
	'A689Mar':'3月',
	'A690Apr':'4月',
	'A691Mai':'5月',
	'A692Jun':'6月',
	'A693Jul':'7月',
	'A694Aug':'8月',
	'A695Sep':'9月',
	'A696Oct':'10月',
	'A697Nov':'11月',
	'A698Dec':'12月',
	'A699Year':'年',
	'A700EnterDateRange':'输入日期范围',
	'A701PowerConsumption':'消耗功率',
	'A702AirConsumption':'耗气量',
	'A703FlowControlGate':'流量控制阀',
	'A704BagDirectionConv':'袋子方向输送机',
	'A705BottomBearing':'底部轴承',
	'A706PressureSwitch':'压力开关',
	'A707ElecModules':'电子模块',
	'A708SpoutWeight':'组件规模',
	'A709Search':'搜索',
	'A710Overweight':'超重袋剔除',
	'A711Underweight':'超轻包剔除',
	'A712RotaryDriveFreqConLoad':'变频旋转驱动',
	'A713MeanValueLoadInPercent':'平均值/负载百分比',
	'A714EmptyBagDischarge':'空袋卸除',
	'A715Bellow1':'波纹管密封',
	'A716TotalCounter':'总计数',
	'A717Spout0Counter':'灌装站 0',
	'A718LSdirtyCounter':'CW 光电开关脏了',
	'A719Peripherie':'周边',
	'A720Robot':'机器人',
	'A721DepositBelt':'放置皮带',
	'A722RollerConveyor1':'滚筒输送机1',
	'A723PalletCentering1':'托盘输送机1',
	'A724RollerConveyor2':'滚筒输送机2',
	'A725PalletCentering2':'托盘输送机2',
	'A726GripperClamp':'夹包器',
	'A727GripperMotor':'夹包电机',
	'A728AdjustmentCamera':'调整相机',
	'A729BagSize':'袋子尺寸',
	'A730PalletSupply':'托盘供应',
	'A731Length':'长度',
	'A732Width':'宽度',
	'A733DepalPallets':'拆垛托盘',
	'A734DepalBundles':'拆垛垛袋',
	'A735RejectedBundles':'丢弃的垛带',
	'A736BagsPerBundle':'每垛袋数',
	'A737CountsOfDataPoints':'数据点计数',
	'A738EmptyKey':'没有密钥',
	'A739TrendMeanWeight':'平均值趋势',
	'A740TrendSD':'标准差趋势',
	'A741PistonBlower1':'活塞式鼓风机 1',
	'A742PistonBlower2':'活塞式鼓风机 2',
	'A743RotaryFlap':'旋转翻板',
	'A744CurrentLayer':'当前层',
	'A745CurrentBag':'当前袋子',
	'A746Days':'天数',
	'A747LayerNo':'层号',
	'A748BagNo':'袋号',
	'A749AnnualMaint':'年度维护',
	'A750GPerSecond':'g/s',
	'A751SortName':'型号',
	'A752PressureTemp':'壓縮空氣溫度',
	'A901MachineCustomerOverview':'设备/ 用户浏览',
	'A902Machines':'设备',
	'A903Permissions':'允许',
	'A904CompanyName':'公司名称',
	'A905MachineName':'设备名称',
	'A906MachineType':'设备型号',
	'A907Order':'订单',
	'A908Action':'行动',
	'A909Remove':'删除',
	'A910ChooseCustomer':'选择客户',
	'A911ConnectMachines':'连接设备',
	'A912User':'用户',
	'A913FirstName':'名',
	'A914Surname':'姓',
	'A915Login':'登录',
	'A916Roles':'职位',
	'A917Company':'公司',
	'A918CreateUser':'创建用户',
	'A919Username':'用户名',
	'A920Password':'密码',
	'A921Name':'名称',
	'A922ParentCompany':'母公司',
	'A923Create':'创建',
	'A924Edit':'编辑',
	'A925SubCompany':'子公司',
	'A926Companies':'公司',
	'A927EditMachine':'编辑设备',
	'A928CompaniesFunctionality':'公司/功能性',
	'A930SelectAll':'全选',
	'A931DetailView':'细节浏览',
	'A932EditUser':'用户编辑',
	'A933Delete':'删除',
	'A934Cancel':'取消',
	'A935Save':'保存',
	'A936LoginFailed':'登录失败',
	'A936Malayalam':'Malayalam',
	'A937DisplayName1':'显示 名称1',
	'A938DisplayName2':'显示 名称2',
	'A939DisplayName3':'显示 名称3',
	'A940ForgotPassword':'忘记密码',
	'A941ForgotText':'没问题，输入您的用户名，您将会收到一封重置密码的链接邮件',
	'A942Submit':'提交',
	'A943EmailAddress':'邮箱地址',
	'A944ChangePassword':'修改密码',
	'A945CurrentPassword':'现用密码',
	'A946NewPassword':'新密码',
	'A947ConfirmPassword':'确认新密码',
	'A948Update':'更新',
	'A949IncorrectPassword':'密码不正确',
	'A950Metrics':'Metricspecs',
	'A950PasswordsNotMatch':'新密码不匹配',
	'A951EmailNotFound':'找不到邮箱地址',
	'A952InvalidEmail':'输入有效的邮箱地址',
	'A953EmailSent':'如果您的电子邮件存在于我们的数据库中，则会通过重置链接将一封电子邮件发送到您的邮件ID',
	'A954ForgetPasswordMailSubject':'重置密码',
	'A955ForgetPasswordMailTitle':'你好，USER_NAME,',
	'A956ForgetPasswordMailBody':'<p>我们收到您重置密码的请求.<br>通过以下链接来重置密码. 如果您没有此请求, 请忽略此邮件该链接会在24小时内失效.<p><a href=\'RESET_LINK\' style=\'text-decoration: none;字体颜色: 白色: inline; border-radius: 2px; border: 0; margin: 0 10px; background: #09174a; color:white; line-height: 15px; width: auto; height: auto; box-sizing: content-box;\'>设置新密码</span></a><br><p>Best regards from the QUAT²RO® Monitoring-Team</p>',
	'A957DateFormat':'dd.MM.yyyy',
	'A958D3DateFormat':'%d/%m/%Y',
	'A959DashboardMachineStateStandBy':'待定',
	'A959MessageUpdateSuccess':'信息已被更新',
	'A960MessageSaveSuccess':'信息已被保存',
	'A961Yes':'是',
	'A962No':'否',
	'A963ReportOverview':'报告浏览',
	'A964Machine':'设备',
	'A965Card':'卡',
	'A966ReportType':'报告方式',
	'A967HistogramReport':'柱状形报告',
	'A968Report':'报告',
	'A969Day':'一天',
	'A969French':'Français',
	'A970Week':'一周',
	'A971Month':'一个月',
	'A972HistoryChart':'历史图表',
	'A972HistoryChartBacth':'历史图表电流。批',
	'A973Unit':'[单位]',
	'A974Time':'计时',
	'A975ShowBagCounterStackChart':'查看包装图形表',
	'A976TestReportStarted':'测试报告生成开始',
	'A977ActiveSettingsRequired':'激活报告设置需先生成测试报告',
	'A978FirstDayRequired':'第一份报告需求时间',
	'A979CompanyDeleted':'公司名被删除',
	'A980CompanyDeleteError':'公司名不能被删除',
	'A981CompanyParentShouldDifferent':'公司名和总公司名称需为不同名称',
	'A982CompanyCreated':'公司名被保存',
	'A983CompanyCreateError':'公司名不能被保存',
	'A984CompanyAllFields':'进入所有板块',
	'A985UserCreated':'用户名被创建',
	'A986UserExists':'邮件账号已存在',
	'A987UserDeleted':'用户被删除',
	'A988IncludedInReport':'包含在报告里',
	'A989IncludedInHistogram':'报告里包含柱状图',
	'A990DateFormat':'DD.MM.YYYY',
	'A991MachineTime':'设备时间',
	'A992LocalTime':'电脑时间',
	'A993NoMachines':'无设备显示',
	'A994Imprint':'标记',
	'A995PrivacyPolicy':'隐私政策',
	'A996Chinese':'中文',
	'A997Portuguese':'Português',
	'A998Vietnamese':'Tiếng Việt ',
	'A999CompanyNameExists':'公司名稱已存在。',
	'B100ActivatingReports':'每次激活都会生成常规报告到下列邮箱地址',
	'B101EnterValidEmailIds':'输入有效的邮箱地址',
	'B101ValidFrom':'生效日期',
	'B102AtleastOneEmailIdRequired':'至少需要一个邮箱账号',
	'B102ValidTo':'有效期至',
	'B103MaximumLimitReached':'达到最大限',
	'C001FetchingWait':'提取数据，请稍等',
	'C002PreparingWait':'准备数据，请稍等',
	'C003RenderingWait':'图表生成中，请稍等',
	'C004PixelScale':'1 像素 ≈ {{时间间隔}}秒 ',
	'C005ChartError':'错误',
	'C006ChartOk':'OK',
	'D001PortalType':'入口',
	'D002CompanyDomain':'观感',
	'E001AlertSettingSavedSuccessfully':'警示设置成功',
	'E002SelectAtLeastOneAlertTypeToActivateAlerting':'选择至少一种警示型号来激活报警系统',
	'E003ErrorNumberMustBePositive':'错误代码必须有效',
	'E004AlertEmailNeedsToBeActive':'警示邮件需被激活',
	'E005AnErrorHasOccured':'错误',
	'E005ErrorMessageAlreadyExists':'信息已经存在',
	'E005OperationSuccesful':'操作成功',
	'E006ErrorMessageSave':'错误，信息未保存',
	'E006ErrorOccurredSettingsWasNotSaved':'错误，设置未保存',
	'E007ReportSettingsSuccessfullySaved':'报告设置成功保存',
	'E008ErrorSettingsDoNotExists':'错误。 设置不存在',
	'E009ReportSettingsSuccessfullyUpdated':'报告设置成功更新',
	'E010InvalidPassword':'无效的密码',
	'E011UserUpdated':'用户更新',
	'E012InvalidPassword':'无效密码',
	'E013UserUpdated':'用户更新成功',
	'E015CompanyMaxUsersLowerThanActiveUsers':'该公司的活跃用户已经超过设置的最大用户数',
	'E016PasswordChangedSuccessfully':'密码修改成功',
	'F001_CurrentOrder':'当前订单',
	'F002_ProductID':'产品编号',
	'F003_BatchStart':'批量开始',
	'F004_Targetweight':'目标重量',
	'F005_RemainingFill':'剩余灌装',
	'F006_CurrentProduction':'当前生产',
	'F007_FillStatistic':'灌装统计',
	'F010_Sum':'总计',
	'F011_Centering':'居中',
	'F012_Debunging':'排除故障',
	'F013_Inert':'料洗',
	'F014_Filling_1':'灌装 1',
	'F015_Filling_2':'灌装 2',
	'F016_Filling_3':'灌装 3',
	'F017_Filling_4':'灌装 4',
	'F018_Bunging':'密封盖',
	'F019_Sealing':'密封',
	'F020_Position':'位置',
	'F021_TransportCycle':'运输周期',
	'F022_CheckWeigher':'复检称',
	'F023_Closing':'关闭',
	'F024_Palletizing':'码垛',
	'F025_EmptyPaletMagazin':'空托盘库',
	'F026_DePalletizing':'码垛机',
	'F027_Transport':'传送',
	'F028_PailSeperator':'提桶分离器',
	'F029_HangUpCap':'开盖',
	'F030_PushInCap':'拧盖',
	'F031_TestConsoles':'测试控制台',
	'F050_TU2':'TU 2',
	'F051_TU1':'TU 1',
	'F052_LowerTol':'低于误差范围',
	'F053_InTol':'在误差范围内',
	'F054_UpperTol':'超过误差范围',
	'F055_TO1':'TO 1',
	'F056_TO2':'TO 2',
	'F060_ProductInfeed':'物料供给',
	'F061_EmptyTruss':'空桁架',
	'F062DetailedDateFormat':'YYYY-MM-DD HH:mm:ss',
	'F090_Minuten':'分钟',
	'F091_Stunden':'时间',
	'F092_Woche':'星期',
	'F100_Eichung':'下一次校准',
	'F101_TransKette':'输送机链条',
	'F102_Hubtor':'提升门',
	'F103_ZentRollen':'对中滚筒',
	'F104_SpundSuch':'桶孔定位器',
	'F105_Aushub':'容器提升',
	'F106_WerkSchlitten':'刀架',
	'F107_Aufschrauber':'开盖时间',
	'F108_VakuSys':'开盖真空系统',
	'F109_HubAufSchraub':'开盖气缸',
	'F110_OelAufSchraub':'开盖润滑',
	'F111_Inertgas':'惰化',
	'F112_Aushub_F1':'容器提升',
	'F113_HE_F1':'提升装置',
	'F114_TFE_F1':'滴漏液收集槽',
	'F115_Aushub_F2':'容器提升',
	'F116_HE_F2':'提升装置',
	'F117_TFE_F2':'滴漏液收集槽',
	'F118_ZentDorn':'中心轴',
	'F119_Schiebetisch':'滑动台',
	'F120_Kappenband':'输送机',
	'F121_VakuKap':'真空分离器',
	'F122_KapSort':'分类',
	'F123_VerKap':'盖分离器',
	'F124_KapZu':'盖塞子',
	'F125_Schrauber':'拧盖',
	'F126_VakuSchrauber':'真空拧盖系统',
	'F127_HubSchrauber':'拧盖气缸',
	'F128_OelZuSchraub':'拧盖润滑',
	'F129_Dichtung':'拧盖头密封',
	'F130_HubClinch':'气缸密封件',
	'F131_Clinchen':'密封',
	'F132_OelClincher':'密封润滑',
	'F133_VakuClincher':'真空密封系统',
	'F140_Startphase':'启动阶段',
	'F141_Grobstromphase':'粗填阶段',
	'F142_Feinstromphase':'精填阶段',
	'F143_DurchflussF1':'流量 F1',
	'F144_DurchflussF2':'流量 F2',
	'G001BatchReport':'批量报告',
	'G002ActivateBatchReport':'激活批量报告',
	'Hülsen MIN-Melder':'低料位计',
	'IVT-Simulation':'INTEGRA® ',
	'Kabel Sattelhöhenv':'袋鞍高度调节电缆',
	'MACHINE_AVAILABILITY_RED_ZONE':'红色区域内设备就绪',
	'MACHINE_AVAILABILITY_YELLOW_ZONE':'黄色区域内设备就绪',
	'Maint Interval 0':'维修间隔 0',
	'Maint Interval 1':'维修间隔 1',
	'Maint Interval 10':'维修间隔 10',
	'Maint Interval 11':'维修间隔 11',
	'Maint Interval 12':'维修间隔 12',
	'Maint Interval 13':'维修间隔 13',
	'Maint Interval 14':'维修间隔 14',
	'Maint Interval 2':'维修间隔 2',
	'Maint Interval 3':'维修间隔 3',
	'Maint Interval 4':'维修间隔 4',
	'Maint Interval 5':'维修间隔 5',
	'Maint Interval 6':'维修间隔6',
	'Maint Interval 7':'维修间隔 7',
	'Maint Interval 8':'维修间隔 8',
	'Maint Interval 9':'维修间隔 9',
	'miniADAMS-Messe':'ROTO-PACKER®',
	'N042BrazAlertGlobalAccL0':'全球加速度超过L0',
	'N042BrazAlertGlobalAccL1':'全球加速度超过L1',
	'N042BrazAlertGlobalAccL2':'全球加速度超过L2',
	'N042BrazAlertGlobalAccL3':'全球加速度超过L3',
	'N042BrazAlertGlobalAccL4':'全球加速度超过L4',
	'N042BrazAlertGlobalAmplL0':'整体振幅越过L0',
	'N042BrazAlertGlobalAmplL1':'整体振幅越过L1',
	'N042BrazAlertGlobalAmplL2':'整体振幅越过L2',
	'N042BrazAlertGlobalAmplL3':'整体振幅越过L3',
	'N042BrazAlertGlobalAmplL4':'整体振幅越过L4',
	'N042BrazAlertMaxRmsAccL0':'LB，CB和RB传感器的最大rms加速度越过L0',
	'N042BrazAlertMaxRmsAccL1':'LB，CB和RB传感器的最大rms加速度越过L1',
	'N042BrazAlertMaxRmsAccL2':'LB，CB和RB传感器的最大rms加速度越过L2',
	'N042BrazAlertMaxTempBearingSensL0':'轴承传感器的最高温度超过L0',
	'N042BrazAlertMaxTempBearingSensL1':'轴承传感器的最高温度超过L1',
	'N042BrazAlertMaxTempBearingSensL2':'轴承传感器的最高温度超过L2',
	'N042BrazAlertMaxZAxisSensorsL0':'lfs，rfs lds和红色传感器的z轴的最大加速度越过L0',
	'N042BrazAlertMaxZAxisSensorsL1':'lfs，rfs lds和红色传感器的z轴的最大加速度越过L1',
	'N042BrazAlertMaxZAxisSensorsL2':'lfs，rfs lds和红色传感器的z轴的最大加速度越过L2',
	'N042BrazAlertRotFreqL0':'旋转频率越过L0',
	'N042BrazAlertRotFreqL1':'旋转频率越过L1',
	'N042BrazAlertRotFreqL2':'旋转频率越过L2',
	'N042BrazAlertRotFreqL3':'旋转频率越过L3',
	'N042BrazAlertRotFreqL4':'旋转频率越过L4',
	'N042BrazAlertType':'巴西警报',
	'N042GlobalAcceleration':'全球加速度超过',
	'N042GlobalAmplitude':'整体振幅',
	'N042GlobalFrequency':'全球频率',
	'N043CardCtxMenuShowConfigScreen':'配置卡',
	'N043ConfigSaveFailure':'配置更新失败',
	'N043ConfigSaveSuccess':'配置更新成功',
	'N044BrazilAlertMailSubject':'Pulse CM Alert : MACHINE_NAME',
	'N045AlertWhenThresholdCrossed':'超过此限制时发出警报',
	'N046RawDataTab':'原始数据',
	'N047SensorL1':'传感器 L 1',
	'N047SensorL4':'传感器 L 4',
	'N047SensorR1':'传感器 R 1',
	'N047SensorR4':'传感器 R 4',
	'N048Acceleration':'加速',
	'N048AccelerationLocal':'本地加速',
	'N048AccelerationX':'加速 X',
	'N048AccelerationY':'加速 Y',
	'N048AccelerationZ':'加速 Z',
	'N048Amplitude':'振幅',
	'N048AmplitudeLocal':'振幅 Local',
	'N048AmplitudeX':'振幅 X',
	'N048AmplitudeY':'振幅 Y',
	'N048AmplitudeZ':'振幅 Z',
	'N048ChooseEndDate':'選擇結束日期',
	'N048ChooseStartDate':'选择开始日期',
	'N048Constant':'不变',
	'N048CourseAngle':'航向角',
	'N048DeltaTemperature':'三角洲温度',
	'N048Frequency':'频率',
	'N048LastSeen':'最后一次露面',
	'N048MovementAngle':'动作角度',
	'N048OffsetX':'X 抵消',
	'N048OffsetY':'Y 抵消',
	'N048OffsetZ':'Z 抵消',
	'N048PhaseAngle':'相位角',
	'N048MotionAngle':'运动角度',
	'N048RMS':'有效值',
	'N048Rpm':'转速',
	'N048SensorDescription':'传感器说明',
	'N048SensorId':'感应器编号',
	'N048SensorTemperature':'传感器温度',
	'N048Side':'侧',
	'N048SiteName':'网站名称',
	'N048UpdatedTime':'更新时间',
	'N049accelFDCompLeft':'Accel.FDComp.Left',
	'N049accelFDCompRight':'Accel.FDComp.Right',
	'N049accelLRCompDisch':'Accel.LRComp.Disch',
	'N049accelLRCompFeed':'Accel.LRComp.Feed',
	'N049Date':'日期',
	'N049ErrorFetchingData':'提取数据时出错',
	'N049FrequencyDaily':'天',
	'N049FrequencyHourly':'小时',
	'N049FrequencyWeekly':'周',
	'N049Length':'长度',
	'N049ModelName':'型号名称',
	'N049pitch':'沥青',
	'N049roll':'滚',
	'N049Rpm':'Rpm',
	'N049strokeDeparture':'中风离开',
	'N049TuningWizard':'调优向导',
	'N049twistG':'Twist.G',
	'N049twistXG':'Twist.XG',
	'N049twistYG':'Twist.YG',
	'N049twistZG':'Twist.ZG',
	'N049Width':'宽度',
	'N049xgFDCompLeft':'X.G.FDComp.Left',
	'N049xgFDCompRight':'X.G.FDComp.Right',
	'N049xgLrCompDisch':'X.G.LRComp.Disch',
	'N049xgLrCompFeed':'X.G.LRComp.Feed',
	'N049ygFDCompLeft':'Y.G.FDComp.Left',
	'N049ygFDCompRight':'Y.G.FDComp.Right',
	'N049ygLrCompDisch':'Y.G.LRComp.Disch',
	'N049ygLrCompFeed':'Y.G.LRComp.Feed',
	'N049zgFDCompLeft':'Z.G.FDComp.Left',
	'N049zgFDCompRight':'Z.G.FDComp.Right',
	'N049zgLrCompDisch':'Z.G.LRComp.Disch',
	'N049zgLrCompFeed':'Z.G.LRComp.Feed',
	'N049zgMax':'ZG.Max',
	'N050AnalystCommentary':'分析师评论',
	'N050mAvgLong':'长',
	'N050mAvgShort':'mavg短',
	'N050TrendAnalysis':'趋势分析',
	'N051SensorL1':'传感器L1',
	'N051SensorL2':'传感器L2',
	'N051SensorL3':'传感器L3',
	'N051SensorL4':'传感器L4',
	'N051SensorMovement':'传感器运动',
	'N051SensorR1':'传感器R1',
	'N051SensorR2':'传感器R2',
	'N051SensorR3':'传感器R3',
	'N051SensorR4':'传感器R4',
	'N052Anomaly':'异常现象',
	'N052AnomalyDetectionTab':'异常检测',
	'N052BrazAlertTypeSL1LocalAmplitudeL0':'传感器L1局部振幅L0',
	'N052BrazAlertTypeSL1LocalAmplitudeL1':'传感器L1局部振幅L1',
	'N052BrazAlertTypeSL1LocalAmplitudeL2':'传感器L1局部振幅L2',
	'N052BrazAlertTypeSL1LocalAmplitudeL3':'传感器L1局部振幅L3',
	'N052BrazAlertTypeSL1LocalAmplitudeL4':'传感器L1局部振幅L4',
	'N052BrazAlertTypeSL1LocalAmplitudeL5':'传感器L1局部振幅L5',
	'N052BrazAlertTypeSL1SensorTempL0':'传感器L1传感器温度超过L0',
	'N052BrazAlertTypeSL1SensorTempL1':'传感器L1传感器温度超过L1',
	'N052BrazAlertTypeSL1SensorTempL2':'传感器L1传感器温度超过L2',
	'N052BrazAlertTypeSL1SensorTempL3':'传感器L1传感器温度超过L3',
	'N052ObservedValue':'观测到的',
	'N053Angle':'角度（0)',
	'N053BrazAlertTypeSL1LocalAccelerationL0':'传感器L1局部加速度越过L0',
	'N053BrazAlertTypeSL1LocalAccelerationL1':'传感器L1局部加速度越过L1',
	'N053BrazAlertTypeSL1LocalAccelerationL2':'传感器L1局部加速度越过L2',
	'N053BrazAlertTypeSL1LocalAccelerationL3':'传感器L1局部加速度越过L3',
	'N053BrazAlertTypeSL1LocalAccelerationL4':'传感器L1局部加速度越过L4',
	'N053BrazAlertTypeSL1LocalAccelerationL5':'传感器L1局部加速度越过L5',
	'N053BrazAlertTypeSl1RotationFreqL0':'传感器L1本地旋转频率L0',
	'N053BrazAlertTypeSl1RotationFreqL1':'传感器L1本地旋转频率L1',
	'N053BrazAlertTypeSl1RotationFreqL2':'传感器L1本地旋转频率L2',
	'N053BrazAlertTypeSl1RotationFreqL3':'传感器L1本地旋转频率L3',
	'N053BrazAlertTypeSl1RotationFreqL4':'传感器L1本地旋转频率L4',
	'N053BrazAlertTypeSl1RotationFreqL5':'传感器L1本地旋转频率L5',
	'N053BrazAlertTypeSL1ZAxisL0':'传感器L1与z轴交叉的加速度L0',
	'N053BrazAlertTypeSL1ZAxisL1':'传感器L1与z轴交叉的加速度L1',
	'N053BrazAlertTypeSL1ZAxisL2':'传感器L1与z轴交叉的加速度L2',
	'N053BrazAlertTypeSL1ZAxisL3':'传感器L1与z轴交叉的加速度L3',
	'N053Displacement':'移位',
	'N053G':'g',
	'N053LocalAmplitude':'局部振幅',
	'N053LocalRotationFrequency':'局部旋转（频率）',
	'N053MM':'mm',
	'N053XAxis':'X轴',
	'N053YAxis':'Y轴',
	'N053ZAxis':'Z轴',
	'N053ZAxisAcceleration':'Z轴加速度',
	'N054Higher':'上',
	'N054Lower':'降低',
	'N054StructuralAnalysis':'结构分析',
	'N054TWvarsForecasts':'TW vars预测',
	'N054TWvarsFull':'TW vars full',
	'N054Value':'数值',
	'N0551On0Off':'1 =开：0 =关',
	'N055BrazTabGeneral':'一般的',
	'N055ChooseStartEndDate':'选择开始日期和结束日期',
	'N055Close':'关闭',
	'N055Custom':'风俗',
	'N055MaterialFlow':'物料流',
	'N055MAxBearingTemperature':'最高轴承温度',
	'N055MaxRmsAccelBearingSensors':'轴承传感器的最大Rms加速度',
	'N055MazAccelZAxis':'结构传感器 的Z轴的最大加速度',
	'N055Off':'离开',
	'N055On':'在',
	'N055RDCenter':'機器視圖',
	'N055ShowHistory':'显示历史',
	'N055StartDateCannotBeAfterEndDate':'开始日期不能晚于结束日期',
	'N056Commentary':'评论',
	'N056EvaluateEquipment':'设备评估条件',
	'N056High80':'高80',
	'N056High95':'高95',
	'N056Importance':'重要性',
	'N056Low80':'低80',
	'N056Low95':'低95',
	'N056MaxLatAccelZgMax':'最大横向加速度ZG.Max',
	'N056Pred':'Pred',
	'N056Recommendations':'推荐建议',
	'N056Type':'类型',
	'N056Report':'报告',
	'N0571Year':'1年',
	'N057AccelGms':'累计',
	'N057AccelRms':'加速度RMS',
	'N057AccelSpectrum':'加速度谱',
	'N057AccelTimeWForm':'加速时间波形',
	'N057Axial':'轴向的',
	'N057CrestFactor':'波峰因数',
	'N057DegreeCelcius':'°C',
	'N057FreqHz':'频率（Hz）',
	'N057FullSpectrum':'全谱',
	'N057FundBearingDefectFreq':'资金，轴承，缺陷频率',
	'N057HighHarBearFreq':'更高的谐波轴承频率',
	'N057HighRes':'高精度',
	'N057HistoricTemperature':'历史温度',
	'N057Horizontal':'水平的',
	'N057Latest':'最新的',
	'N057LowHarBearFreq':'较低的谐波轴承频率',
	'N057mms':'mm/s',
	'N057PeakToPeak':'峰峰',
	'N057PeakToPeakMg':'峰峰(mg)',
	'N057PowerBands':'功率带',
	'N057RedAlert':'红色警报',
	'N057Rmsmg':'Rms(mg)',
	'N057Rmsmms':'Rms(mm/s)',
	'N057SensorLB1':'传感器LB1',
	'N057SensorLB2':'传感器LB2',
	'N057SensorRB1':'传感器RB1',
	'N057SensorRB2':'传感器RB2',
	'N057SensorCB1':'传感器CB1',
	'N057SensorCB2':'传感器CB2',
	'N057Spectrum':'光谱',
	'N057Temperature':'温度',
	'N057TimeMs':'时间（毫秒）',
	'N057Trending':'趋势',
	'N057VelocityRms':'速度RMS',
	'N057Vertical':'垂直的',
	'N057X1Rpm':'1X Rpm',
	'N057YellowAlert':'黄色警报',
	'N058ImageUploadedFailure':'图片上传失败',
	'N058ImageUploadedSuccesfully':'图片上传成功',
	'N058UploadImage':'上传图片',
	'N059Print':'打印',
	'N060MachineHistoricalData':'设备历史数据',
	'N061HistoricalBearingData':'历史关系数据',
	'N062HistoricalSpectrumData':'历史范围数据',
	'N063GlobalAcceleration':'全球积累',
	'N064RotationFrequency':'旋转（频率）',
	'N065GlobalBreadth':'全球幅度',
	'N066LocalAccelerationsEachStructureSensor':'各感应器速度',
	'N067MotionAngleEachStructureSensor':'每个结构传感器的运动角度',
	'N067PhaseAngleEachStructureSensor':'每个结构传感器的相位角',
	'N067LocalAmplitudesEachStructureSensor':'各感应器振幅',
	'N068LateralAccelerationsStructureSensor':'各感应器侧向加速',
	'N069TemperatureEachBearingSensor':'各轴承感应器温度',
	'N070PeakToPeakEachBearingSensor':'各轴承感应器峰值',
	'N071AccelerationRMS':'加速RMS',
	'N072VelocityRMS':'速度RMS',
	'N073CrestFactor':'波峰因素',
	'N074PowerBandsSensorLB1':'功率带-感应器LB1',
	'N075PowerBandsSensorRB1':'功率带-感应器RB1',
	'N076PowerBandsSensorLB2':'功率带-感应器LB1',
	'N077PowerBandsSensorRB2':'功率带-感应器RB2',
	'N077PowerBandsSensorCB1':'功率带-感应器CB1',
	'N077PowerBandsSensorCB2':'功率带-感应器CB2',
	'N078TimeWaveformDataAcceleration':'时间波形数据-加速',
	'N079FrequencyDomainAcceleration':'频域',
	'N080Select':'选择',
	'N081SelectedPeriod':'选择时段',
	'N100Capacity':'能力',
	'N101Product':'产品',
	'N102Undersized':'小于正常 ',
	'N103Oversized':'大于正常',
	'N104Speed':'速度RMS',
	'N105Inclination':'倾向',
	'N106BoardHeigh':'高度',
	'N107Moisture':'湿度',
	'N108WaterAdd':'水量',
	'N109OpMode':'操作模式',
	'N110Auto':'自动模式',
	'N110Hand':'手动模式',
	'N111OpHours':'操作时间',
	'N112Temp':'温度',
	'N113BearingTemp1':'轴承温度1',
	'N114BearingTemp2':'轴承温度2',
	'N115DriveTemp':'驱动器温度',
	'N116ConvTemp':'转换器温度',
	'N117PowerInput':'电源输入',
	'New001BagTransArea':'袋输送区域',
	'New002EmptyPalArea':'空托盘区',
	'New003FullPalArea':'满托盘区',
	'New004SheetDispArea':'空托盘覆膜机',
	'New005PneuFalut':'气动故障',
	'New006ElectricFault':'电动故障',
	'New007Introduction':'介绍',
	'New008Orientation':'定向',
	'New009PreGrouping':'预分组',
	'New010Grouping':'分组',
	'New011RowPusher':'推板',
	'New012SlideTable':'滑台 & 整形板',
	'New013Elevator':'提升器',
	'New014Gantry':'机架',
	'New015Gripper':'抓手',
	'New016FilmDispenser':'空托盘覆膜机',
	'New017FullPalTrans':'满托盘输送',
	'New018EmpPalDisp':'空托盘分离器',
	'New019FilmDisp':'空托盘覆膜机',
	'New020EmpCardDisp':'纸板分离机',
	'New021EmpPalTrans':'空托盘输送机',
	'New022EjectingDev':'剔除装置',
	'New023MetDetector':'金属检测',
	'New024MarkingDev':'喷码机',
	'New025LabellingDev':'标签机',
	'New026PalletStracker':'托盘码垛',
	'New027PalletPress':'压垛',
	'New028Wrapper':'缠膜/套膜机',
	'New029Fault':'故障',
	'New030StandBy':'暂停',
	'New031BagProduction':'生产包数',
	'New032WeightDetection':'重量检测',
	'New033LeakingDetection':'遗撒检测',
	'New034PrintingFault':'打印错误',
	'New035BagProduced':'已生产包数',
	'New036SamplingEjection':'样品退回',
	'New037PalletProduction':'托盘数',
	'New038PalletInfeed':'托盘净给',
	'New039PalletOutfeed':'托盘输出',
	'New040PalletIncomplete':'未完成托盘',
	'New041Checkweigher':'复检称',
	'New041PalledProduced':'托盘数',
	'New042ProgramChngsToday':'今天程序修改',
	'New042ProgramChngs':'程序修改',
	'New043EndofBatch':'批次结尾',
	'New044ProductonTime':'生产时间',
	'RVT8-Messe':'ROTO-PACKER® ',
	'RVT8-Simulation':'ROTO-PACKER® ',
	'TERAM2-Messe':'TERRAM®',
	'TERAM-Messe':'TERRAM®',
	'Typ84-Messe':'INTEGRA® ',
	'Waagenabgleich':'校称',
	'Zyklen':'循环',
	'N082AlertMe':'当此卡有任何警报时提醒我',
	'N083TimeFormat':'HH:mm',
	'N090Synced':'同步',
	'N091NotSynced':'不同步',
	'N084New':'最新的',
	'N085ConfigSettingSavedSuccessfully':'参数设置保存成功',
	'N86ErrorOccurredSettingsWasNotSaved':'参数设置保存错误',
	'A496OEEWeek':'每两周',
	'A497OEEMonthly':'每月最佳操作',
	'N87ServiceRequestUploadFiles':'长传文件',
	'N88ServiceRequestFileSizeError':'文件过大',
	'N89ServiceRequestFileTypeError':'不支持此文件类型',
	'N90FilesUploadedSuccesfully':'成功上传文件',
	'N91FilesUploadedFailure':'上传文件错误',
	'N932IncludeExcelReport':'包括excel报告',
	'N94ServiceRequestFileLimitError':'文件过大',
	'N055MaxHAxisRmsAccelBearingSensors':'最大水平RMS加速',
	'N055MaxAxialRmsAccelBearingSensors':'最大纵向RMS加速',
	'N053MG':'mg',
	'N056DummyMachine':'Dummy machines',
	'N057NiagaraAlertYellow':'黄色警报',
	'N058NiagaraAlertOrange':'橙色警报',
	'N059NiagaraAlertRed':'红色警报',
	'N060AddDummyMachine':'增加虚拟机器',
	'N96ConfigureValue':'配置值',
	'N97NoDataAvailable':'没有可用数据',
	'N98TimeStamp':'时间戳',
	'N99Documentation':'文档',
	'N100ErrorFileHeader':'错误信息',
	'N101DocumentationHeader':'文档标题',
	'N102DownloadMachineTypeErrorMessageFile':'默认机器型号',
	'N102DownloadMachineErrorMessageFile':'机器错误文件',
	'N103ErrorInRetrievingErrorMessages':'检索错误信息时出错',
	'E011MaintIntervalSubmitSuccess':'维护间隔已成功保存',
	'A368OpenPartsShop':'打开备件目录',
	'N104ExtSparePartCatalog':'HAVER备件目录',
	'N105OpenExtSparePartCatalog':'打开HAVER备件目录',
	'N106LperH':'l/h',
	'N107Degree':'°',
	'N107DegreeText':'° (Degree)',
	'N108UseRelativeValues':'undefined',
	'N109PartsShopUsername':'undefined',
	'N110Tons':'t',
	'AX_VibratingBodyCondition':'震动状态',
	'AX_BearingCondition':'存储状态',
	'AX_AlarmsCount':'报警次数',
	'AX_Last24Hours':'过去24小时',
	'D001TransBearingCondition':'良好',
	'D002TransBearingCondition':'良好| 递减',
	'D003TransBearingCondition':'良好| 稳定',
	'D004TransBearingCondition':'良好| 递增',
	'D005TransBearingCondition':'可接受',
	'D006TransBearingCondition':'可接受| 递减',
	'D007TransBearingCondition':'可接受| 稳定',
	'D008TransBearingCondition':'可接受| 递增',
	'D009TransBearingCondition':'严重',
	'D010TransBearingCondition':'严重| 递减',
	'D011TransBearingCondition':'严重| 稳定',
	'D012TransBearingCondition':'严重 递增',
	'D013TransBearingCondition':'危急',
	'D014TransBearingCondition':'危急| 递减',
	'D015TransBearingCondition':'危急| 稳定',
	'D016TransBearingCondition':'危急 递增',
	'D001TransVBCondition':'良好',
	'D002TransVBCondition':'良好| 递减',
	'D003TransVBCondition':'良好| 稳定',
	'D004TransVBCondition':'良好| 递增',
	'D005TransVBCondition':'可接受',
	'D006TransVBCondition':'可接受| 递减',
	'D007TransVBCondition':'可接受| 稳定',
	'D008TransVBCondition':'可接受| 递增',
	'D009TransVBCondition':'严重',
	'D010TransVBCondition':'严重| 递减',
	'D011TransVBCondition':'严重| 稳定',
	'D012TransVBCondition':'严重 递增',
	'D013TransVBCondition':'危急',
	'D014TransVBCondition':'危急| 递减',
	'D015TransVBCondition':'危急| 稳定',
	'D016TransVBCondition':'危急 递增',
	'F01CardExpProduction':'<p><strong>生产率 </strong>是设备当前的性能体现，表示为<strong> 每小时的件数 </strong>。<br>- 件数 = 货件<p><p>该<strong> 颜色变换 </strong>定义如下：<br>- 红&nbsp; 0-70%<br>- 黄&nbsp; 70-90%<br>- 绿&nbsp; 90-100%</p><p><strong> 最大生产率 </strong>定义为 <u>合同规定产量</u> 的包装系统或定制机型的<u> 特定产出量。</u></p>',
	'F01CardExpAvailability':'<p><strong>可用率 </strong>是设备当前的可用率，表示为<strong> 百分比</strong>。</p><p>该<strong>可用率 </strong>的 100% 定义如下：<br>- 控制电压已开启<br>- 收尘系统运行中<br>- 有压缩空气可用<br>- 没有设备组的中断<br>- 所有的灌装站都投入运行<br>- 有插袋机可用并投入运行</p><p>该<strong> 颜色变换 </strong>定义如下：<br>- 红&nbsp; 0-70%<br>- 黄&nbsp; 70-90%<br>- 绿&nbsp; 90-100%</p>',
	'F01CardExpMaintenance':'<p><strong>设备维护 </strong>是整个设备的维护计数，按<strong> 件数 </strong>。<br>- 件数 = 货件</p><p>该<strong> 阈值 </strong>无法通过此门户修改。<br>请联系<strong> HAVER 热线 </strong>来做修改。<br>eMail：<a href=\"mailto:hotline@haverboecker.com\">hotline@haverboecker.com</a></p>',
	'F01CardExpProductionTime':'<p><strong>总时间 </strong>显示设备当天总的生产时间，表示为<strong> 分钟数</strong>。</p><p>该<strong> 解释说明 </strong>情况如下：<br>- 深蓝：&nbsp; 设备的纯<em> 生产时间 </em><br>- 浅蓝：&nbsp; 下游 <em> 输送系统 </em>中断<br>- 灰：&nbsp; 没有<em> 物料  </em>可用<br>- 黄：&nbsp; 没有<em> 包材  </em>可用 (例如： 空袋、桶 或 托盘)<br>- 绿：&nbsp;<em> 设置时间  </em>， 例如更换物料或品种<br>- 红：&nbsp;<em> 停机时间  </em>，没有其他状态激活且控制电压激活</p>',
	'F01CardExpProductionTimeBaumit':'<p><strong>中断 </strong>显示设备当天生产时间，表示为<strong>  分钟数 </strong>。</p><p><strong>解释说明 </strong>信息为以下中断源：<br>- 青色：&nbsp;<em>没有卸包</em>，例如下游输送系统中断<br>- 橄榄色：&nbsp;<em>没有物料 </em>可用<br>- 橙色：&nbsp;<em>没有包材 </em>可用 (例如：空袋、桶或托盘)<br>- 紫色：&nbsp;<em>停机 </em>，是各组的停机总时间</p>',
	'F01CardExpProductionToday':'<p><strong>今日产量 </strong>是今天当前日产量，按<strong> 件数</strong>。<br>- 件数 = 货件</p>',
	'F01CardExpRemProduction':'<p><strong>总产量 </strong>是计数器记录的总计数，按<strong> 件数</strong>。<br>- 件数 = 货件</p><p>该数据 <em> 无法重置。  </em></p>',
	'F01CardExpLastReset':'<p><strong>最近重置 </strong>是指机器数据最近重置的时间<strong>。 </strong><br>-<em>时区 </em>由机器本地确定</p><p>该 <strong>时间戳 </strong>所显示的时间为<em> 协调世界时 </em><strong> (UTC) </strong>为机器所在之地的时间。 </p>',
	'F01CardExpFaults_C':'<p><strong>今日中断</strong>是所有发生的故障的次数总和，按<strong> 次数</strong>。</p><p>详细清单之<strong>故障次数 </strong>可以在机器特定的页面找到 (第2选项卡)。</p>',
	'F01CardExpFaults_M':'<p><strong>今日中断 </strong>时所有发生的故障的时间总和，按<strong> 分钟数</strong>。</p><p>详细清单之<strong>故障时间</strong>按<strong> 分钟 </strong>可以在机器特定的页面找到 (第2选项卡)。</p>',
	'F01CardExpEnergy':'***Coming Soon***',
	'F01CardExpFillingTime':'***Coming Soon***',
	'F01CardExpBagManufacture':'<p><strong>合格产品 </strong>是质量指标，指 <em>重量合格</em> 数所含的<strong> 百分比</strong>。</p><p>该值为<u>今日产量</u> 和 <u>剔包数</u>的比率。</p><p>该<strong> 颜色区间 </strong>定义如下：<br>- 红&nbsp; 0-70%<br>- 黄&nbsp; 70-90%<br>- 绿&nbsp; 90-100%</p>',
	'F01CardExpWeightData':'<p><strong>平均值</strong> 是当前每个灌装站的平均重量， 按本地使用的<strong>重量单位</strong> (kg 或 lb)。</p><p>该平均重量总是指的 <u>当前品种</u>。改选品种后，重量数据会清零。</p>',
	'F01CardExpStdDevData':'<p><strong>标准差</strong> 是当前每个灌装站的标准偏差， 按本地使用的<strong>重量单位</strong> (g 或 lb)。</p><p>该标准偏差总是指的 <u>当前品种</u>。改选品种后，重量数据会清零。</p>',
	'F01CardExpIncorrectWeight':'***Coming Soon***',
	'F01CardExpInterrupts':'<p><strong>今日中断详情 </strong>是将中断按不同的生产区域进行细分，按<strong> 次数 </strong>和<strong> 分钟</strong>。</p><p>- 1. 列： 次数<br>- 2. 列： 分钟时长 （总中断之和）</p>',
	'F01CardExpTypeChange':'<p><strong>更换品种 </strong>是设备所有品种的更换次数，按<strong> 次数</strong>。</p><p> <strong> 更换品种 </strong>始于在设备上<em>接受品种 </em>。<br>终于卸下 <em> 第一 </em>包 <u>新的</u>品种<strong>， </strong>并将计数器值加1。</p>',
	'F01CardExpBagCounterPerFS':'<p><strong>今日计数 </strong>是每个灌装站详细的包装数量，按<strong> 件数 </strong>和<strong> 百分比</strong>。</p><p>- 1.列： 件数 = 货件<br>- 2.列： 百分比 = 详细百分比 (&sum; = 100%)</p>',
	'F01CardExpNotPlacedBags':'<p><strong>没插好的袋子 </strong>是每个灌装站详细的故障插袋数，按 <strong> 件数 </strong>和<strong> 百分比。</strong></p><p>- 1.列： 件数 = 货件<br>- 2.列：百分比 = 与已生产包数的详细百分比</p>',
	'F01CardExpEmptyBagMagazineToday':'<p><strong>袋仓补袋 </strong>是补充袋子到包装机袋仓的次数，按<strong>次数 </strong>。</p>',
	'F01CardExpRejectsToday':'***Coming Soon***',
	'F01CardExpCollectiveFaultsToday':'<p><strong>总故障 </strong>是所有详细故障次数和分钟数，发生在<em> 插袋机 </em>以及安装的<em> 各灌装站， </em> 按<strong> 次数 </strong>和<strong> 分钟数</strong>。<br>- 1.列：次数<br>- 2.列：分钟时长 (故障的总和)</p>',
	'F01CardExpGoodWeights':'<p><strong>合格产品 </strong>是指<em>重量合格</em>的包数，按<strong> 百分比</strong>。</p><p>该比值，为 <u>今日生产数</u> 和 <u>剔除包数</u>。</p><p>该<strong>颜色变换 </strong>定义如下：<br>- 红&nbsp; 0-70%<br>- 黄&nbsp; 70-90%<br>- 绿&nbsp; 90-100%</p>',
	'F01CardExpFltCompAir':'***Coming Soon***',
	'F01CardExpStrokesPump':'***Coming Soon***',
	'F01CardExpMaxStrokeDur':'***Coming Soon***',
	'F01CardExpAvgStrokes':'***Coming Soon***',
	'F01CardExpInternalPressure':'***Coming Soon***',
	'F01CardExpFillings':'***Coming Soon***',
	'F01CardExpStartOfOrder':'***Coming Soon***',
	'F01CardExpProductID':'***Coming Soon***',
	'F01CardExpTargetWeight':'***Coming Soon***',
	'F01CardExpFillingCount':'***Coming Soon***',
	'F01CardExpRemainingNumberFillings':'***Coming Soon***',
	'F01CardExpCycleTime':'***Coming Soon***',
	'F01CardExpFaultLength':'***Coming Soon***',
	'F01CardExpExtFaultLength':'***Coming Soon***',
	'F01CardExpWithinTolerance':'***Coming Soon***',
	'F01CardExpOutsideTolerance':'***Coming Soon***',
	'F01CardExpCurrentProduction':'***Coming Soon***',
	'F01CardExpFillStatistic':'***Coming Soon***',
	'F01CardExpRDCenter':'***Coming Soon***',
	'F01CardExpGlobalAcceleration':'***Coming Soon***',
	'F01CardExpGlobalFrequency':'***Coming Soon***',
	'F01CardExpGlobalAmplitude':'***Coming Soon***',
	'F01CardExpMazAccelZAxis':'***Coming Soon***',
	'F01CardExpMaxHAxisRmsAccelBearingSensors':'***Coming Soon***',
	'F01CardExpMaxRmsAccelBearingSensors':'***Coming Soon***',
	'F01CardExpMaxAxialRmsAccelBearingSensors':'***Coming Soon***',
	'F01CardExpMAxBearingTemperature':'***Coming Soon***',
	'F01CardExpSensorMovement':'***Coming Soon***',
	'F01CardExpAccelerationLocal':'***Coming Soon***',
	'F01CardExpAcceleration':'***Coming Soon***',
	'F01CardExpAxisAcceleration':'***Coming Soon***',
	'F01CardExpLocalRotationFrequency':'***Coming Soon***',
	'F01CardExpLocalAmplitude':'***Coming Soon***',
	'F01CardExpDisplacement':'***Coming Soon***',
	'F01CardExpPhaseAngle':'***Coming Soon***',
	'F01CardExpMotionAngle':'***Coming Soon***',
	'F01CardExpSensorTemperature':'***Coming Soon***',
	'F01CardExpBagQuality':'***Coming Soon***',
	'F01CardExpFaults':'***Coming Soon***',
	'F01CardExpBunChangeAbs':'***Coming Soon***',
	'F01CardExpBunChangeToday':'***Coming Soon***',
	'F01CardExpBagsPerBundle':'***Coming Soon***',
	'F01CardExpTypeChanges':'***Coming Soon***',
	'F01CardExpSortChangeToday':'<p><strong>今日更换品种</strong>是设备所有更换的品种数量<strong> 按次数</strong>。</p><p>该 <strong> 品种更换 </strong> 由在机器上的 <em> 接受品种 </em> 触发。<br>当卸出 <em> 第一 </em>包 <u>新</u> 品种，就 结束<strong> 更换品种 </strong>并且计数器的读数就加1。</p>',
	'F01CardExpCyclesToday':'***Coming Soon***',
	'F01CardExpMetalDetectorToday':'***Coming Soon***',
	'F01CardExpIncorrectBags':'<p><strong>剔除的重量不合格包数 </strong>是机器所有检测到的重量不合格的袋数总和，按<strong>包数 </strong>。</p>',
	'F01CardExpOpenBags':'<p><strong>剔除的袋子开口的包数 </strong>是所有检测到的袋子开口或者封口不好的袋子数，按<strong>包数</strong>。</p>',
	'F01CardExpSampleBags':'<p><strong>剔除的取样袋包数 </strong>是机器所有取样生产的袋数，按<strong> 包数</strong>。</p>',
	'F01CardExpRejectionsToday':'<p><strong>剔除袋数 </strong>是所有过重或欠重而剔除的袋数，按<strong> 包数 </strong>。</p><p>剔除信号的<strong> 剔除 </strong>直接由复检称发出，如果可以，<br>重量不够或者重量过多的袋子都可以被检测出来。</p>',
	'F01CardExpContainer':'<p><strong>Container </strong>is the breakdown of all produced packaging per container given in<strong> units</strong> and in<strong> percent</strong>.</p><p>- 1. Column: Units = Items<br>- 2. Column: percent = percentage breakdown (&sum; = 100%)</p>',
	'F01CardExpEmptyRejects':'<p><strong>今日空袋剔除数 </strong>是没插好的袋子的剔除的数量，按<strong> 包数</strong>。</p>',
	'F01CardExpFullRejects':'<p><strong>今日灌装剔除数 </strong>是所有阀口打开或者重量不合格的袋子的数量，按<strong> 包数</strong>。</p',
	'F01CardExpProductionRate':'***Coming Soon***',
	'F01CardExpDailyProduction':'<p><strong>今日产量 </strong>是当前按天的生产量，按<strong> kg</strong>。</p>',
	'F01CardExpFillingStation':'***Coming Soon***',
	'F01CardExpPalletizer':'***Coming Soon***',
	'F01CardExpEmptyPalArea':'***Coming Soon***',
	'F01CardExpBagTransArea':'***Coming Soon***',
	'F01CardExpFullPalArea':'***Coming Soon***',
	'F01CardExpSheetDispArea':'***Coming Soon***',
	'F01CardExpProductonTime':'***Coming Soon***',
	'F01CardExpProgramChngsToday':'***Coming Soon***',
	'F01CardExpEndofBatch':'***Coming Soon***',
	'F01CardExpEmptyPallets':'***Coming Soon***',
	'F01CardExpBagProduction':'***Coming Soon***',
	'F01CardExpPalletProduction':'***Coming Soon***',
	'F01CardExpFSDifference':'<p><strong>袋子计数之差 </strong>是 <u>性能最好</u> 和 <u>性能最差</u> 的灌装站之间的质量差异，按<strong>百分比</strong>。</p>',
	'F01CardExpProduct':'***Coming Soon***',
	'F01CardExpCapacity':'***Coming Soon***',
	'F01CardExpUndersized':'***Coming Soon***',
	'F01CardExpOversized':'***Coming Soon***',
	'F01CardExpSpeed':'***Coming Soon***',
	'F01CardExpInclination':'***Coming Soon***',
	'F01CardExpBoardHeigh':'***Coming Soon***',
	'F01CardExpMoisture':'***Coming Soon***',
	'F01CardExpWaterAdd':'***Coming Soon***',
	'F01CardExpOpMode':'***Coming Soon***',
	'F01CardExpOpHours':'***Coming Soon***',
	'F01CardExpTemp':'***Coming Soon***',
	'F01CardExpPowerInput':'***Coming Soon***',
	'F01CardExpFullPalletCount':'***Coming Soon***',
	'F01CardExpLoadEmptyPallets':'***Coming Soon***',
	'F01CardExpOeeValue':'<p><strong>OEE 测量 </strong>是当前测量的 <strong>设备综合效率</strong>， 按<strong> 百分比</strong>。</p><p>&nbsp;</p><p>该 <strong>设备综合效率 </strong>包含如下因素 <i>可用性</i>，<i>性能水平</i>和 <i>质量比</i>。</p>',
	'F01CardExpOeeAvailable':'<p><strong>可用性 </strong>是当前测量的 <strong>可用性</strong>， 按<strong> 百分比</strong>.</p><p>&nbsp;</p><p>该 <strong>可用性系数</strong> 是指故障发生前的时长与功能故障的时长的比值。</p>',
	'F01CardExpOeePerformance':'<p><strong>性能 </strong>是当前测量的 <strong>性能</strong>， 按<strong> 百分比</strong>。</p><p>&nbsp;</p><p>该 <strong>性能系数</strong>是测量到的损失，如由于偏离计划单位时间，轻微故障（未计入的停机时间 <i>可用性 </i>) 和空闲时间。</p>',
	'F01CardExpOeeQuality':'<p><strong>质量 </strong>是当前测量的<strong>质量</strong> ，按<strong> 百分比</strong>.</p><p>&nbsp;</p><p>The <strong>质量系数</strong>是测量到的损失，如 <i>工件损坏 </i>和 <i>返工的工件</i></p></i>。</p>',
	'F01CardExpOeeDowntime':'<p><strong>停机时间 </strong>是设备不同停机时间的总和的可视化呈现，用于计算<i>可用性系数 </i>按<strong>分钟</strong>.</p><p>&nbsp;</p><p>该 <strong>说明</strong>提供有关以下类型停机时间的信息：<br>- 黄： <i>其他停机时间</i><br>- 灰： <i>设备停机时间</i><br>- 浅蓝： <i>计划停机时间</i></p>',
	'F01CardExpOperatingFactor':'<p><strong>运行系数 </strong>是测量设备的纯运行时间，用来计算 <i>性能系数 </i> 按 <strong>百分比</strong>。</p>',
	'F01CardExpThroughput':'<p><strong>生产量 </strong>是测量机器纯正常运行的时间，用来计算 <i>性能系数 </i> 按 <strong>百分比</strong>。</p>',
	'F01CardExpOeeRejects':'<p><strong>今日剔包 </strong>是机器不同的分配的卸包的详细情况，用来计算 <i>质量系数</i> ，按<strong> 件数</strong>。<br>- 件数 = 个数</p>',
	'F01CardExpMachineDetailPage':'<p>该 <strong>切换按钮</strong> 用来切换 <u>每天数值</u> 和 <u>品种数值</u>。</p><p>所选品种的可视化通过以下额外显示为<span style=\"color:#000\"> <u>蓝</u> </span>或<span style=\"color:#000\"> <u>橙</u> 标题图标。</p><p>默认设置为 <u>每天数据</u>。</p>',
	'F01CardExpReportSettingsPage':'<p>在 <strong>报告</strong> 部分，您可以对报告进行修改。</p><p>您可以通过华东开关来启用/禁用报告。</p><p>在 <strong>频率</strong>下面，你可以选择创建报告的时间间隔。能选择多个时间间隔。</p><p>在 <strong>动态内容</strong> 部分，您可以更改更多设置。<br>-<u>已用维护间隔：</u> 每一个单独的维护间隔，超过了100%的阈值之后，将会在报告中得以显示。<br>-<u>激活批次报告：</u> 在更改完品种/产品后，前一个品种/产品的报告会送出来。<br>-<u>包含EXCEL的报告：</u>报告数据也将已CSV文件发送。</p><p>选择报告语言<br>选择报告创建时间<br>选择每周的第一天发送报告，当按周报/月报发送时</p><p>修改完成后，按 <strong>保存</strong>。',
	'F01CardExpReportOverviewPage':'<p>在 <strong>报告概览</strong> 中，列出了报告中选定的数据点。</p><p>要删除 <u>单个</u> 数据点，点击<strong>红色标记</strong>。</p><p> 点击 <strong>垃圾桶图标</strong> 您可以删除 <u>所有</u> 报告中的数据点。</p><p> 要生成一个测试报告，点击 <strong>向下的箭头</strong>。</p>',
	'F01CardExpCompanyOverviewPage':'<p>在 <strong>仪表板注册表</strong> 会显示工厂所有已连接的机器。</p><p>要查看更多的图卡的信息，点击单独的帮助按钮。</p><p>如需了解更多信息，选择左侧列表中相关的机器。</p><p>该<strong> 状态 </strong>定义如下：<br>- 蓝：&nbsp; 运行中<br>- 红：&nbsp; 故障<br>- 灰：&nbsp; 就绪<br>- 白：&nbsp; 需要维护<br>- 黑：&nbsp; 已关闭</p>',
	'F01CardExpAlertSettingsPage':'<p>在 <strong>提醒部分</strong> 您可以更改提醒设置。</p><p>通过 <strong>激活</strong>您可以切换推送通知（左侧）和/或邮件通知（右侧）。</p><p>在下面，您可以选择单个 <strong>事件</strong>做通知。</p><p>更改完成之后，按 <strong>保存</strong>。',
	'F01CardExpMsgAdminPage':'<p>在 <strong>消息部分</strong> 您可以为FFS触发器声明预定义的故障消息以及其属性。</p>',
	'F01CardExpUserRolesPage':'<p>在 <strong>用户 &amp; 角色 </strong>部分，可以为TYP门户创建新的用户。</p><p>点击 <span style=\"color:#2980b9\"> 蓝色</span> +号，填写需要的数据：</p><ul><li>名字</li><li>姓氏</li><li>登录 / eMail-地址</li><li>角色 (管理员 或 户)</li><li>公司</li></ul><p>该 <strong>管理员 / 用户 &amp; 角色 </strong>部分，仅对TYP门户的管理员可见。</p>',
	'F01CardExpCompaniesPage':'<p>在 <strong>公司 </strong>部分，可以为TYP门户创建新公司。</p><p>点击<span style=\"color:#2980b9\"> 蓝色</span>  + 号，并填写所需数据：</p><ul><li>公司名称</li><li>公司内TYP门户的最大用户数</li><li>Look&amp;外观</li><li>母公司</li></ul><p>该 <strong> 管理 / 公司 </strong>部分，仅对TYP门户的管理员可见。</p>',
	'F01CardExpDummyMachinePage':'<p>用 <strong>虚拟机器</strong>部分，可以在TYP门户里插入或者删除机器。</p><p>点击<span style=\"color:#2980b9\"> 蓝色</span> + 号 bet&auml;tigen填写所需的数据。</p><p>该 <strong> 管理 / 虚拟机器 </strong>部分，只对TYP门户的管理员可见。</p>',
	'F01CardExpPermissionsPage':'<p>在 <strong>权限 </strong>部分，您可以为每个公司单独启用/禁用TYP门户的所有功能。</p><p>要这么做， 选择相关公司，然后进行相应的设置。</p><p>该 <strong> 管理 / 权限 </strong>部分，仅对TYP门户的管理员可见。</p>',
	'F01CardExpMaintenanceAidPage':'<p>该 <strong>维护辅助工具 </strong>部分，您可以上传对应的维护工具，给 <u>机器维护登记</u>。</p><p>选择相关的客户和机器，然后上传文件。支持WORD、PDF文档以及照片和视频。</p><p>该 <strong> 管理 / 维护辅助工具 </strong>部分，仅对TYP门户的管理员可见。</p>',
	'F01CardExpMachinePage':'<p>在 <strong>机器 </strong>部分，您可以为TYP门户创建新的机器。</p><p>点击 <span style=\"color:#2980b9\"> 蓝色</span> + 号，填写所需的数据：</p><p>该 <strong> 管理 / 机器 </strong>部分，仅对TYP门户的管理员可见。</p>',
	'F01CardExpLogBookTab':'<p>在寄存器 <strong>日志 </strong> 中，会显示整个设备的报警信息。</p><p>首先，激活警报消息的创建功能，在 <u>警报 </u> 部分 （左侧）。</p><p>之后，所有的 <u>警报信息</u> 会列在日志中。</p><p>此外，可以随时创建日志条目。日志类型区分为 <u>信息</u>、 <u>任务</u> 和 <u>警报</u>。</p>',
	'F01CardExpServiceRequestTab':'<p>在 <strong>服务请求</strong>部分， 您能对设备和TYP门户提各种请求。</p><p>此外，您可以上传更多的信息，例如文档，照片或者视频。</p>p>该 <strong>服务请求</strong>将直接发送给热线负责该 <u>机型</u>的人，并得到及时处理。</p>',
	'F01CardExpMessagesTab':'<p>在寄存器 <strong>机器信息</strong>您可以查看HMI上所有已注册的信息。</p><p>那些信息按组别分为：</p><p>- 故障信息 (FM</p><p>-操作信息 (OM)</p><p>- 等待信息 (WM)</p>',
	'F01CardExpDocumentSTab':'***Coming Soon***',
	'F01CardExpOeeTab':'<p>寄存器 <strong>OEE </strong>显示工厂的整体设备效率，已百分比表示。</p>',
	'F01CardExpMaintenanceTab':'<p>寄存器 <strong>机器维护记录 </strong>能显示到200条整个设备的维护间隔。</p><p>维护间隔氛围不同的组别。</p><p>你可以把某个维护间隔设置到0，通过 <u>重置</u> 功能。</p><p>下拉菜单会显示属于这一组的所有的维护间隔。</p><p>设置的阈值与技术文档中的规范一致，或由 H&amp;B 服务人员提供经验值.</p><p>该<strong> 颜色变化 </strong>定义如下：<br>- 绿&nbsp; 0-70%<br>- 黄&nbsp; 70-90%<br>- 红&nbsp; 90-100%</p>',
	'F01CardExpMachineSpecificTab':'<p>在 <strong>机器相关 </strong> 寄存器中，与机型相关的信息回显示出来。</p><p>图卡的更多详细信息，可以通过相应的按钮调看。</p>',
	'F01CardExpGeneralTab':'<p>该 <strong>总览 </strong>寄存器显示整个设备的总的信息。</p><p>图卡的更多详细信息，可以通过相应的按钮调看。</p><p>该寄存器 <strong>总览</strong>与机器无关。通用术语 <u>件数</u>被采用</p>',
	'F01CardExpGoodPerformance':'<p><strong>今日产量</strong>是整个设备的详细生产包数，按<strong> 件数</strong>。<br>- 件数 = 货件</p><p>- 总产量：&nbsp; 所有卸包的总和。<br>- 没插好的袋子：&nbsp; 所有没有插好的空袋数量总和。<br>- 剔除：&nbsp; 所有剔除的包数总和。<br>- 不合格重量：&nbsp; 所有剔除的重量不够/过重的包数之和。<br>- 阀口打开：&nbsp; 所有封口不好的袋子的总和。</p>',
	'F01CardExpWrongApplBags':'<p><strong>没插好的袋子 </strong>是所有没有插好的空袋的总和，按<strong> 包数</strong>。</p>',
	'F01CardExpReelChanges':'<p><strong>今日更换袋卷 </strong>是机器已完成的所有的袋卷数，按<strong> 卷数</strong>。</p>',
	'F01CardExpTypeCurrent':'<p><strong>当前品种 </strong>是机器当前生产的产品/品种名称。</p><p>&nbsp;</p><p> 如果有产品/品种名称，它直接从复检接受，否则从MEC® 计量系统接受。</p>',
	'F01CardExpInterruptsFeigeGeneral':'***Coming Soon***',
	'F01CardExpInterruptsAdams':'***Coming Soon***',
	'F01CardExpInterruptsISF':'***Coming Soon***',
	'F01CardExpInterruptsIVT':'***Coming Soon***',
	'F01CardExpInterruptsMiniAdams':'***Coming Soon***',
	'F01CardExpInterruptsRVT':'***Coming Soon***',
	'F01CardExpInterruptsNewtecTerram':'***Coming Soon***',
	'A-AlertTip-main_acc-ORANGE':'主加速橙色警报',
	'A-AlertTip-main_acc-YELLOW':'主加速黄色警报',
	'A-AlertTip-main_acc-RED':'主加速红色警戒',
	'A-AlertTip-u8MachAvail-AVAIL':'可用性警报',
	'A905MachineNameNotAllowedCharacter':'不允许使用以下字符: !, @, #, $, %, ^, &, *, (, ), [, ], {, }, |, ~, \\, =, +, ,, ;, <, >, ?, /',
	'A1000ReportSystemMessage':'系统消息',
	'A1001ReportSystemMessageOffline':'设备的MACHINENAME之CARDNAME卡片不会显示出来，因为它在最近的96小时内没有生产任何产品。',
	'A1002ReportOverviewHeaderOrder':'订单',
	'A1003ReportSystemMessageCardNotForReportType':'设备的MACHINENAME之CARDNAME卡片不会显示在REPORTTYP的报告中。',
	'A1004DrillLeft':'undefined',
	'A1005DrillRight':'undefined',
	'A1006DrillMiddle':'undefined',
	'A1007DrillNew':'undefined',
	'A1008LatheLeft':'undefined',
	'A1009LatheRight':'undefined',
	'A1010LatheMiddle':'undefined',
	'A1011RunDrillLeft':'undefined',
	'A1012RunDrillRight':'undefined',
	'A1013RunDrillMiddle':'undefined',
	'A1014RunDrillNew':'undefined',
	'A1015RunLatheLeft':'undefined',
	'A1016RunLatheRight':'undefined',
	'A1017RunLatheMiddle':'undefined',
	'A1018Speeds':'undefined',
	'A1019RunOverall':'undefined',
	'A1020MiddleClamps':'undefined',
	'A1021OuterClamps':'undefined',
	'A1022VibBottle':'undefined',
	'A1023VibTable':'undefined',
	'A1024AdjVibTable':'undefined',
	'A1025BagHoldVibTable':'undefined',
	'A1026ExhaustFillFunnel':'undefined',
	'A1027SpillageFlap':'undefined',
};